import { ChangeDetectorRef, ElementRef, Injectable } from '@angular/core';
import {SclMappingFunctionOpenLayersService} from './scl-mapping-function-open-layers.service';
import {SclMappingFunctionsArcGisService} from './scl-mapping-functions-arc-gis.service';
import {SclMappingFunctionGoogleService} from './scl-mapping-function-google.service';
import * as isEqual from 'lodash/isEqual';
import { FormbirdInjectorService } from 'formbird-services';
import {SclMapConstantService} from './scl-map-constant.service';
import { SclUtilMapService } from './scl-util-map.service';
import {sclHandlebars} from '../../../formbird-sc-shared/src/lib/handlebars/sclHandlebars';
import {SearchResultsProcessor} from '@formbird/shared';
import {HttpClient} from '@angular/common/http';
import { cloneDeep, find } from 'lodash';
import { NotificationService } from '../../../formbird-services/src/lib/services/notification/notification.service';
import { SclMapViewsService } from './scl-map-views.service';
import { MapDrawType, MapLibraryName, MapComponentName, MapSelectAssetType, FEATURE_TYPE } from './map-library';


const formbirdInjectorService = new FormbirdInjectorService();
const fileProviderService = formbirdInjectorService.get('FileProviderService');
const sclUtilMapService = new SclUtilMapService();
const sclMapViews = new SclMapViewsService();


@Injectable({
  providedIn: 'root'
})
export class SclMappingFunctionsService {

  //
  isGoogle = false;
  isInit = false;
  updateWatchFields = []; // 14164
  updateWatchFieldsObj; // 14164
  libName = ''; // 14337
  MapFunc; mapObj;
  changedDocumentService;
  subs;
  document;
  updateWatchFieldsLayerKey = {}; // 14934
  layersCount = 0; // 14934
  watchDocOldValue = {};
  assetIconResources = {};
  initObj;
  isOnline = false;
  currentLocation = null;
  updateAddress = null;
  visualizeSelectedAsset = [];
  loadAssetCounter = 0;
  divInfo: ElementRef;
  divInfo1: ElementRef;
  divInfoCluster: ElementRef;
  targetMapElement;
  intervalToolTipSetup = null; countIntervalTooltipSetup = 0; hasCustomControl = false; // 15336#c59379
  tooltipHandleBarObjects: any;
  toolTipTimeout = undefined;
  tooltipsTimeout = null;
  previousSelectedFeature;
  isPopoverOpen = false;
  focusPopup;
  currentPopover = null;
  tooltipInfo;
  tooltipText;
  infoPosition = {left: '0px', top: '0px'};
  isPopupClusterOpen = false;
  compType = -1;
  mouseX = 0;
  mouseY = 0;
  mouseStopInterval;
  lastEvt = null;
  mapCenter;
  tooltipRadioPosition;
  infoRadioPosition;
  tooltipPosition;
  infoClusterPosition;
  isPopupRadioOpen = false;
  pixelPopup;
  isToolTipScroll;
  mapHeight;
  componentDefinition;
  updateWatchFieldsLayer = { }; // <fieldName, [layerIndex1, layerIndex2]> //14164
  hasUpdateWatchField = false;
  EPSG = SclMapConstantService.EPSG_3857;
  layerAssets = [];
  minZoomAsset = 0;
  maxZoomAsset = 0;
  currentBox = null;
  lstLoadedOriginFilter = []; // 16005
  lstLoadedOriginFilterAfterHandlebar = {};
  requestId;
  isRequesting = false;
  countFinishQueries = 0; // 15861
  showTiming = false;
  pageSize = 10000;
  primaryAssetAddressField; secondaryAssetAddressField;
  primaryAssetGeometryField; secondaryAssetGeometryField;
  relatedAssetQuery = [];
  asyncDrawAsset = false;
  contextParams: any;
  uwfFilterCalled = []; countUwfFilterDone = 0; // 15838, store filter called by updateWatchField
  hasResize = false; // 15861
  disableHandlebars = false; // 15250
  loadInitialMapView; // selected-asset
  setPositionForAsset; // selected-asset
  setSelectedAssetVisualize; // selected-asset
  featureCollections; // selected-asset
  createFeature; // selected-asset, boundary, street-address
  systemMapLimit; // 17023  [ [ top, left ], [bottom, right ] ]
  countAssetPoint = 0;
  relatedAsset: any = {};
  getToolTips;
  defaultImageAnchor = [ 0.5, 1.0 ];
  processPageSize = 20;
  disableProcessingOnLoad = false;
  countLoadingProcess = 0;
  popupAssetSelectionPrimaryText = ''; // selected-asset
  popupAssetSelectionSecondaryText = ''; // selected-asset
  createNewFeature; // address-map
  updateExistedFeature; // address-map
  finishSearchAsync; // address-map
  geoAutoComplete: any;
  keyName;
  currentLat = 0;
  currentLon = 0;
  hasMapDragging = false; // 15058 // selected-asset
  subLabelTiming = 'Unknow-Source'; // 15250#c62803 // selected-asset
  updateMap; // selected-asset && street-address
  addressId;
  locationElementLabel;
  locationElementLabelId;
  locationElementCheckboxId;
  locationElementIcon;
  currentLocationCheckBoxOnClick;
  checkMapReadyFirstLoad = null;
  canvasRotate;
  deleteAfterMaxZoom = false;
  searchClientService: any;
  keyValueStorageService: any;
  offlineStatusService: any;
  previousShowMapView = null;
  // 20117
  mapWrapperChange = null; resizeMapTime; resizeMapTimeout = false; resizeMapThreshold = 200;
  prevMapWrapperRect: any = {};
  hasMapWrapperResize = false;
  onMoveEndFn = null;
  mapWrapperChangeOptions = null;
  //
  isDisableAddressEntry = false;
  pencilElements = [];

  constructor(public httpClient: HttpClient,
    private cdRef: ChangeDetectorRef,
    private notificationService: NotificationService,) {
      this.searchClientService = formbirdInjectorService.get('SearchClientService');
      this.keyValueStorageService = formbirdInjectorService.get('KeyValueStorageService');
      this.offlineStatusService = formbirdInjectorService.get('OfflineStatusService');


      this.isOnline = this.offlineStatusService.offlineStatus.connected;
      console.log(`**** isOnline = ${this.isOnline}`);

      this.offlineStatusService.offlineStatus$.subscribe((offlineStatusData: any) => {
        if (this.isOnline !== offlineStatusData?.connected) {
          this.isOnline = offlineStatusData.connected;
          this.mapObj.isOnline = this.isOnline;
          if (this.isOnline == true && Array.isArray(this.currentLocation) && this.currentLocation.length == 2) {
            console.log('Became online');
  
            this.updateAddress(this.currentLocation[0], this.currentLocation[1]);
            this.currentLocation = null;
          } else if (this.isOnline === false) {
            console.log('Became offline');
          }
        }
        
      });
  
  }


  initLib(pInstance, libName, constructObj, cb, changeDocumentService?: any, subs?: any, document?: any) {
    this.changedDocumentService = changeDocumentService;
    this.subs = subs;
    this.document = document;
    if (this.isInit) { return; }
    this.updateWatchFieldsObj = {};
    this.MapFunc = pInstance;
    this.isInit = true;
    this.isGoogle = false;
    this.libName = libName;

    if (libName === MapLibraryName.GOOGLE) {
      this.isGoogle = true;
      this.mapObj = new SclMappingFunctionGoogleService();
      this.mapObj.load(constructObj, function() {
        if (cb && typeof cb === 'function') {
          cb(this.mapObj);
        }
      }.bind(this));
    } else if (libName === MapLibraryName.OPEN_LAYER) {
      this.mapObj = new SclMappingFunctionOpenLayersService();
      this.mapObj.load(this.keyValueStorageService, function() {
        if (cb && typeof cb === 'function') {
          cb(this.mapObj);
        }
      }.bind(this));
    } else if (libName === MapLibraryName.ARC_GIS) {
      this.mapObj = new SclMappingFunctionsArcGisService();
      this.mapObj.load(function() {
        if (cb && typeof cb === 'function') {
          cb(this.mapObj);
        }
      }.bind(this));
    }
    this.mapObj.libName = this.libName;
  }

  async setupMap(pInstance, initObj, keyName) {
    this.MapFunc = pInstance;
    this.initObj = initObj;


    this.intervalToolTipSetup = this.initObj.intervalToolTipSetup;
    this.countIntervalTooltipSetup = this.initObj.countIntervalTooltipSetup;
    this.hasCustomControl = this.initObj.hasCustomControl;
    this.tooltipInfo = this.initObj.tooltipInfo;
    this.compType = this.initObj.style;
    this.componentDefinition = this.initObj.componentDefinition;
    this.keyName = this.initObj.keyName;
    initObj.getLocationFn = this.getLocation.bind(this); // 14786#c56443


    if (this.componentDefinition) {
      initObj.checkMapEmptyLogError = this.componentDefinition.checkMapEmptyLogError;
      if (this.componentDefinition.disableProcessingOnLoad) {
        this.disableProcessingOnLoad = this.componentDefinition.disableProcessingOnLoad;
      }

      if (this.componentDefinition.relatedFields) {
        for (const field in this.componentDefinition.relatedFields) {
          if (this.componentDefinition.relatedFields.hasOwnProperty(field)) {
            const fieldAsset = this.componentDefinition.relatedFields[field];
            this.relatedAsset[field] = fieldAsset;
            this.relatedAssetQuery.push(fieldAsset);
          }
        }
      }

      if (this.componentDefinition.processPageSize) { this.processPageSize = this.componentDefinition.processPageSize; }// 14752

      if (this.componentDefinition.layers) {
        let idx = 0;
        for (let i = this.componentDefinition.layers.length - 1; i > -1; i--) {
          idx++;
          // 1. logic for options updateWatchFieldsLayer
          if (typeof this.componentDefinition.layers[i].updateWatchFields !== 'undefined') {
            for (let j = 0; j < this.componentDefinition.layers[i].updateWatchFields.length; j++) {
              const key = this.componentDefinition.layers[i].updateWatchFields[j];
              if (key in this.updateWatchFieldsLayer) {
                if (this.updateWatchFieldsLayer[key].indexOf(idx) > -1 ) { continue; }

                this.updateWatchFieldsLayer[key].push(idx);

              } else {
                this.updateWatchFieldsLayer[key] = [idx];
              }
            }
            this.hasUpdateWatchField = true;
          }
        }
      }

      if (this.componentDefinition.deleteAfterMaxZoom) {
        this.deleteAfterMaxZoom = this.componentDefinition.deleteAfterMaxZoom;
      }
    }

    this.layersCount = this.layerAssets.length;
    this.mapObj.isOnline = this.offlineStatusService.offlineStatus.connected;
    await this.mapObj.init(initObj, keyName);

    this.updateWatchFieldsObj = {
      updateWatchFieldsLayer: this.updateWatchFieldsLayer,
      layers: this.componentDefinition.layers,
      layerAssets: this.layerAssets,
      watcherFunction: this.initObj.watcherFunction,
      searchLayerFunc: this.loadAssetUWF.bind(this),
    };
    if (this.updateWatchFieldsObj && this.updateWatchFieldsObj.updateWatchFieldsLayer) {
      for (const key in this.updateWatchFieldsObj.updateWatchFieldsLayer) {
        if (this.updateWatchFieldsObj.updateWatchFieldsLayer.hasOwnProperty(key)) {
          const docKey = key.replace('document.', '');
          if (this.watchDocOldValue.hasOwnProperty(docKey) ) {
            this.watchDocOldValue[docKey] = null;
          }
        }
      }
    }
    this.updateWatchFields = [];
    this.createWatchField();
    this.creatWatchDocument();

  }

  fitCoords(geoJson) {
    if (!this.mapObj || !geoJson || geoJson.length === 0) { return; }
    const coorDatas = [];
    for (let i = 0; i < geoJson.length; i++) {
      const feature = geoJson[i];
      const geometries = feature.geometries || [feature.geometry];

      if (Array.isArray(geometries)) {
        for (let g = 0; g < geometries.length; g++) {
          const geom = geometries[g];
          if (geom && Array.isArray(geom.coordinates) && geom.coordinates.length > 0
           && typeof geom.type === 'string' ) {
            if (geom.type === MapDrawType.POINT) { coorDatas.push(geom.coordinates);
            } else { sclUtilMapService.traverseCoords(geom.coordinates, coorDatas); }
          }
        }
      }
    }

    this.mapObj?.fitCoords(coorDatas);
  }


// main function center of linestring
  getPointByDistance(pnts, distance) {
    const tl = this.totalLen(pnts);
    let cl = 0;
    let ol;
    let result;
    const self = this;
    pnts.forEach(function(point, i, points) {
      ol = cl;
      cl += i ? self.lineLen([points[i - 1], point]) : 0;
      if (distance <= cl && distance > ol) {
        const dd = distance - ol;
        result = self.pntOnLine([points[i - 1], point], dd);
      }
    });
    return result;
  }
  // returns a point on a single line (two points) using distance // line=[[x0,y0],[x1,y1]]
  pntOnLine(line, distance) {
    const t = distance / this.lineLen(line);
    const xt = (1 - t) * line[0][0] + (t * line[1][0]);
    const yt = (1 - t) * line[0][1] + (t * line[1][1]);
    return [xt, yt];
  }

  // returns the total length of a linestring (multiple points) // pnts=[[x0,y0],[x1,y1],[x2,y2],...]
  totalLen(pnts) {
    let tl = 0;
    if (!pnts) { return; }
    const self = this;
    pnts.forEach(function(point, i, points) {
      tl += i ? self.lineLen([points[i - 1], point]) : 0;
    });
    return tl;
  }
  // returns the length of a line (two points) // line=[[x0,y0],[x1,y1]]
  lineLen(line) {
    if (!line || !Array.isArray(line) || line.length < 2) { return 0; }
    const xd = line[0][0] - line[1][0];
    const yd = line[0][1] - line[1][1];
    return Math.sqrt(xd * xd + yd * yd);
  }




  // copy and modify from scope.sclUtilMap.isContainAsset
  isContainAsset(asset, assets) {
    if (!assets) {
      return false;
    }
    let id = asset.properties.linkAssets[0].documentId;
    if (id && id.indexOf('_')) { id = id.split('_')[0]; }

    for (let i = 0; i < assets.length; i++) {
      const ass = assets[i];
      let idass = ass.properties.linkAssets[0].documentId;
      if (idass && idass.indexOf('_')) { idass = idass.split('_')[0]; }
      if (idass.indexOf(id) > -1 && asset.properties.type === ass.properties.type ) {
        return true;
      }
    }
    return false;
  }

  addHeatmapData(weight, coorData, centerPoint, options, type) {
    if (!this.mapObj || !this.mapObj.heatDatas || !this.mapObj.lstHeatWeight) { return; }
    let isAdd = false;
    let k = 0;
    for (k = 0; k < this.mapObj.heatDatas.length; k++) {
      if (this.mapObj.heatDatas[k].coorData[0] === coorData[0] && this.mapObj.heatDatas[k].coorData[1] === coorData[1]) {
        weight += this.mapObj.heatDatas[k].weight;
        isAdd = true;
        break;
      }
    }
    if (isAdd) {
      this.mapObj.heatDatas[k].weight = weight;
    } else {
      this.mapObj.heatDatas.push({id: options.id , name: options.name, location: centerPoint, coorData, weight, type});
      this.mapObj.lstHeatWeight.push(weight);
    }
  }

  createHeatMapData(coordinates, type, weight, isGoogleMap, options) {
    if (!this.mapObj || (isGoogleMap && !this.mapObj.google) ) { return; }
    weight = (weight == null ? 1 : parseFloat(weight) );

    if (options.heatmapPoints === 'Center') {
      let centerPoint = sclUtilMapService.getCenterOfGeometry(coordinates, type);
      const coorData = [centerPoint[0], centerPoint[1]];
      if (isGoogleMap) {
        centerPoint = new this.mapObj.google.maps.LatLng(centerPoint[1], centerPoint[0]);
      }

      this.addHeatmapData(weight, coorData, centerPoint, options, type);
    } else if (options.heatmapPoints === 'Points') {
      let coorDatas = [];
      if (type === MapDrawType.POINT) { coorDatas = [coordinates];
      } else { sclUtilMapService.traverseCoords(coordinates, coorDatas); }
      for (let i = 0; i < coorDatas.length; i++) {
        let point = [coorDatas[i][0], coorDatas[i][1]];
        if (isGoogleMap) {
          point = new this.mapObj.google.maps.LatLng(coorDatas[i][1], coorDatas[i][0]);
        }

        this.addHeatmapData(weight, coorDatas[i], point, options, type);
      }

    }
  }



  // begin 14164: timing of drawing of "layers" sometimes some layers aren't showing
  createWatchField() {
    if (!this.updateWatchFieldsObj || !this.updateWatchFieldsObj.updateWatchFieldsLayer) {
      return;
    }
    for (const key in this.updateWatchFieldsObj.updateWatchFieldsLayer) {
      if (this.updateWatchFieldsObj.updateWatchFieldsLayer.hasOwnProperty(key)) {
        const docKey = key.replace('document.', '');
        // if(key.indexOf('document.') > -1 && (docKey in scope.doc) && this.updateWatchFields.indexOf(key) < 0 ){
        if (key.indexOf('document.') > -1 ) {
          this.createWatchDoc(docKey);
        }
      }
    }
  }

  createWatchDoc(docKey) {
    if (this.updateWatchFields.indexOf('document.' + docKey) > -1) { return; }
    this.updateWatchFields.push('document.' + docKey);
    if (this.updateWatchFieldsLayerKey == null) { this.updateWatchFieldsLayerKey = {}; }
    // if (this.compType === MapComponentName.ADDRESS_MAP) { // sc-address-map
    //     this.updateWatchFieldsLayerKey['document.' + docKey] = '';
    // } else { // sc-selected-asset
    //   this.updateWatchFieldsLayerKey['document.' + docKey] = [];
    //   for (let i = 0; i < this.layersCount; i++) {
    //     this.updateWatchFieldsLayerKey['document.' + docKey].push('');
    //   }
    // }
    this.updateWatchFieldsLayerKey['document.' + docKey] = [];
    for (let i = 0; i < this.layersCount; i++) {
      this.updateWatchFieldsLayerKey['document.' + docKey].push('');
    }
    const docKeySub = this.changedDocumentService.watch(docKey, this.document.documentId, {forceWatch: true}).subscribe(newValue => {
      if (!isEqual(this.watchDocOldValue[docKey], newValue)) {
        this.watchDocOldValue[docKey] = cloneDeep(newValue);
        this.document[docKey] = cloneDeep(newValue);
        this.updateFilter('document.' + docKey);
      }
    });
    this.subs.add(docKeySub);
  }
  creatWatchDocument() {
    if (!this.document || !this.document.documentId) { return; }
    const docSub = this.changedDocumentService.watchDocument(this.document.documentId).subscribe(newValue => {
      // console.log('%c lib, watch all doc, oldValue = ' + JSON.stringify(oldValue), 'color:blue');
      // console.log('%c lib, watch all doc, newValue = ' + JSON.stringify(newValue), 'color:blue');

      if (this.updateWatchFieldsObj) {
        if (typeof this.updateWatchFieldsObj.watcherFunction === 'function') {
          this.updateWatchFieldsObj.watcherFunction(newValue); // 16772#0068539
        }

        if (this.updateWatchFieldsObj.updateWatchFieldsLayer) {
          for (const key in this.updateWatchFieldsObj.updateWatchFieldsLayer) {
              if (this.updateWatchFieldsObj.updateWatchFieldsLayer.hasOwnProperty(key)) {
                const docKey = key.replace('document.', '');
                // if(newValue.hasOwnProperty(docKey) && this.updateWatchFields.indexOf(key) < 0 ){
                if (newValue.hasOwnProperty(docKey) ) {
                  // console.log('%c lib, create watch doc key 1 = ' + key + ', docKey = ' + docKey, 'color:blue');
                  this.createWatchDoc(docKey);
                }
              }
            }
        }
      }

      for (const key in newValue) {
        if (newValue.hasOwnProperty(key)) {
          const docKey = key.replace('document.', '');
          // console.log('%c lib, create watch doc key 3 = ' + key + ', docKey = ' + docKey, 'color:blue');
          this.createWatchDoc(docKey);
        }
      }

    });
    this.subs.add(docSub);
  }


  updateFilter(key) {
    if (typeof this.updateWatchFieldsObj.layers === 'undefined' || this.updateWatchFieldsObj.layers === null) { return; }
    if (key in this.updateWatchFieldsObj.updateWatchFieldsLayer) {
      for (let i = 0; i < this.updateWatchFieldsObj.updateWatchFieldsLayer[key].length; i++) {
        const layerIndex = this.updateWatchFieldsObj.updateWatchFieldsLayer[key][i];
        // console.log("updateFilter, key = " + key + ", layer" + layerIndex);
        for (let j = 0; j < this.updateWatchFieldsObj.layerAssets.length; j++) {
          if (layerIndex === this.updateWatchFieldsObj.layerAssets[j].i) {
            this.mapObj?.clearAllFeaturesLayer(layerIndex);
            if (this.updateWatchFieldsObj.searchLayerFunc && typeof this.updateWatchFieldsObj.searchLayerFunc === 'function') {
              this.updateWatchFieldsObj.searchLayerFunc({
                layer: this.updateWatchFieldsObj.layerAssets[j].layer,
                layerKey: key,
                layerIndex: layerIndex
              });
            }
            break;
          }
        }
      }
    }
  }
  // end 14164

  checkLayerKey(layerKey, layerFilter){
    // if (this.compType === MapComponentName.ADDRESS_MAP
    //    && this.updateWatchFieldsLayerKey.hasOwnProperty(layerKey)
    //  && this.updateWatchFieldsLayerKey[layerKey] === layerFilter) { // sc-address-map
    //     return true;
    // } else if (this.updateWatchFieldsLayerKey.hasOwnProperty(layerKey)
    //  && this.updateWatchFieldsLayerKey[layerKey].indexOf(layerFilter) > -1) { // sc-selected-asset
    //     return true;
    // }
    if (this.updateWatchFieldsLayerKey.hasOwnProperty(layerKey)
     && this.updateWatchFieldsLayerKey[layerKey].indexOf(layerFilter) > -1) { // sc-selected-asset
        return true;
    }
    return false;
  } // 14934

  // old logic of sclMapRulesInterface
  setCurrentMapviewCoords(component, componentName, value) {
    // this.setRCGlobal
    const variable = 'MapBoundingBox';
    const varName = component + '_' + componentName + '_' + variable;
    window[varName] = value;
    // console.log('library MapFunctions, setRCGlobal: window[' + varName + '] = ' + JSON.stringify(window[varName]));
  }

  getCurrentMapviewCoords(component, componentName) {
    // this.getRCGlobal
    const variable = 'MapBoundingBox';

    const varName = component + '_' + componentName + '_' + variable;
    // console.log('library MapFunctions, getRCGlobal: window[' + varName + '] == ' + JSON.stringify(window[varName]));
    return window[varName];
  }

  getAssetIcon(imageFileNo) {
    // console.log('*** assetIconResources = ', this.assetIconResources);
    // console.log('*** imageFileNo = ' + imageFileNo);
    return new Promise(async (resolve, reject) => {
        if (this.assetIconResources[imageFileNo]) {
          // console.log('*** getAssetIcon, imageFileNo 111 = ' , this.assetIconResources[imageFileNo]);
          resolve(this.assetIconResources[imageFileNo]);

        } else {

          try {
            const file = { fileNo: imageFileNo, fileName: '' };
            this.assetIconResources[imageFileNo] = await fileProviderService.getFileResources(file);
            // console.log('*** getAssetIcon, imageFileNo 222 = ' , this.assetIconResources[imageFileNo]);
            resolve(this.assetIconResources[imageFileNo]);
          } catch (err) {
            reject(err);
          }

        }
    });
  }
  // 15828 : offline map
  debugIconUrl = [];
  isShowLogDebugIconUrl = false;
  async getIcon (iconUrl) {
    this.isShowLogDebugIconUrl = false;
    if (this.debugIconUrl.indexOf(iconUrl) < 0) {
      this.debugIconUrl.push(iconUrl);
      this.isShowLogDebugIconUrl = true;
    }

    if (iconUrl !== null && iconUrl.trim().length > 0) {
      iconUrl = sclUtilMapService.handleImageFileNo(iconUrl);
      
      const invalidChars = ['/', '\\']; // remove at the end invalid chars
      let countInvalid = 0;
      for (let i = iconUrl.length - 1; i > -1; i--) {
        if (invalidChars.indexOf(iconUrl.charAt(i)) < 0) {
          break;
        }
        countInvalid++;
      }
      iconUrl = iconUrl.substring(0, iconUrl.length - countInvalid);
    }
    // if (this.isShowLogDebugIconUrl) {
    //   console.log('**** icon = ' + iconUrl);
    // }
    return iconUrl;
  }

  showMap(fnShowMap) {
    setTimeout(() => {
      if (!this.mapObj) { return; }
      this.mapObj.updateSize();
      this.mapObj.heightMapInit = this.initObj.target.offsetHeight;
      if (this.libName === MapLibraryName.OPEN_LAYER) {
        this.mapObj.findCanvas();
      }
      if (fnShowMap && typeof fnShowMap === 'function') {
        fnShowMap();
      }
    }, 100);
  }

  updateLabelByZoom() {
    if (!this.mapObj) { return; }
    if (this.libName === MapLibraryName.OPEN_LAYER) {
      this.mapObj.updateLabelByZoom();
    }
  }

  updateLabelAllLayers() {
    if (!this.mapObj) { return; }
    if (this.libName === MapLibraryName.GOOGLE) {
      this.mapObj.updateLabelAllLayers();
    }
  }

  updateLabel(feature, label) {
    if (!this.mapObj) { return; }
    if (this.libName === MapLibraryName.OPEN_LAYER) {
      this.mapObj.updateLabel(feature, label);
    }
  }

  updateRotateScaleByZoom() {
    if (!this.mapObj) { return; }
    if (this.libName === MapLibraryName.GOOGLE) {
      this.mapObj.updateRotateScaleByZoom();
    }
  }

  project( p, a, b ) {

    const atob = { x: b[0] - a[0], y: b[1] - a[1] };
    const atop = { x: p[0] - a[0], y: p[1] - a[1] };
    const len = atob.x * atob.x + atob.y * atob.y;
    let dot = atop.x * atob.x + atop.y * atob.y;
    const t = Math.min( 1, Math.max( 0, dot / len ) );

    dot = ( b[0] - a[0] ) * ( p[1] - a[1] ) - ( b[1] - a[1] ) * ( p[0] - a[0] );
    const pX = a[0] + atob.x * t;
    const pY = a[1] + atob.y * t;

    return {
        point: {
            x: pX,
            y: pY
        },
        left: dot < 1,
        dot: dot,
        t: t
    };
  }

  insidePolygon(point, vs) {
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

    var x = point[0], y = point[1];

    var inside = false;
    for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i][0], yi = vs[i][1];
        var xj = vs[j][0], yj = vs[j][1];

        var intersect = ((yi > y) != (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }

    return inside;
  }

  isOnLine(currPoint, point1, point2) {
    const dxc = currPoint[0] - point1[0];
    const dyc = currPoint[1] - point1[1];

    const dxl = point2[0] - point1[0];
    const dyl = point2[1] - point1[1];

    let cross = dxc * dyl - dyc * dxl;
    if (cross != 0) { return false; }
    return true;
  }

  getNearestPointWithPolygon(coords, clickedPoint) {
    if (!this.mapObj) { return; }
    let a = coords[0][0]; let b = coords[0][1];
    let min = this.project(clickedPoint, a, b);
    let distance = this.mapObj.psmaDistanceCoords(clickedPoint, [min.point.x, min.point.y]);

    for (let i = 0; i < coords.length; i++) {
      const iMin = this.project(clickedPoint, coords[i][0], coords[i][1]);
      let iDistance = this.mapObj.psmaDistanceCoords(clickedPoint, [iMin.point.x, iMin.point.y]);

      if (iDistance < distance && !isNaN(iMin.point.x) && !isNaN(iMin.point.y)) {
        min = iMin;
        distance = iDistance;
      }
    }

    return [min.point.x, min.point.y];
  }

  getNearestPoint(feature, clickedPoint) {
    if (this.libName === MapLibraryName.ARC_GIS) {
      return clickedPoint; // not support arcGIS yet so return clickedPoint
    }
    if (!this.mapObj) { return clickedPoint; }

    if (!feature || (Array.isArray(feature) && feature.length == 0)) {
      return clickedPoint;
    }
    if (this.libName === MapLibraryName.GOOGLE && feature && Array.isArray(feature)
     && feature.length > 0) {
      feature = feature[0].feature;
    }

    // get coordinates of feature
    const obj = this.mapObj.getFeatureCoordinate(feature);
    const coords = obj.coords;
    const coordArray = obj.coordArray;
    const type = obj.type;

    let isInsideShape = true;
    if (type !== MapDrawType.POINT) {
      isInsideShape = this.insidePolygon(clickedPoint, coordArray);
    }
    if (isInsideShape) {
      return clickedPoint;
    }

    if ((type === MapDrawType.LINE_STRING || type === MapDrawType.MULTI_LINE_STRING) && this.libName === MapLibraryName.GOOGLE) {
      return clickedPoint;
    }

    if (type == MapDrawType.POINT) {
      return clickedPoint;
    } else if (type == MapDrawType.MULTI_POINT) {
      let min = coords[0];
      let distance = this.mapObj.psmaDistanceCoords(clickedPoint, min);

      for (let i = 0; i < coords.length; i++) {
        let iDistance = this.mapObj.psmaDistanceCoords(clickedPoint, coords[i]);
        if (iDistance < distance) {
          min = coords[i];
        }

      }

      return min;
    } else if (type == MapDrawType.LINE_STRING) {
      let isOnALine = false;
      for (let i = 0; i < coords.length; i++) {
        isOnALine = this.isOnLine(clickedPoint, coords[i][0], coords[i][1]);
        if (isOnALine) {
          break;
        }
      }
      if (isOnALine) { return clickedPoint; }

      return this.getNearestPointWithPolygon(coords, clickedPoint);

    } else {
      return this.getNearestPointWithPolygon(coords, clickedPoint);
    }
  }


  tooltipOnFeatureHover(e, mapLibName) {
    if (!this.mapObj) { return; }
    let selectedFeatures = [];
    if (mapLibName === MapLibraryName.OPEN_LAYER) {
      if (e.target.getFeatures()) {
        selectedFeatures = e.target.getFeatures().array_;
      }
    } else if (mapLibName === MapLibraryName.GOOGLE) {
      selectedFeatures = [e.feature];
    } else {
      selectedFeatures = [e];
    }
    if (selectedFeatures && selectedFeatures.length > 0) {
      const selectedFeature = selectedFeatures[0];
      const existingTooltip = this.mapObj.getFeatureProperty(selectedFeature, 'tooltip');
      if (!existingTooltip) {
        this.getTooltipData(selectedFeature);
      }

    }

  }
  getTooltipData(selectedFeature) {
    if (!this.mapObj) { return; }
    const p = this.mapObj.getFeatureProperties(selectedFeature, ['id', 'zIndex']);
    const hbObject = find(this.tooltipHandleBarObjects, {id: p.id, layerIndex: p.zIndex});
    if (hbObject) {
      const popup = sclHandlebars.processHandlebars(hbObject.tooltips,
      hbObject.handlebarsContext, null, null, hbObject.contextParams);
      this.mapObj.setFeatureProperties(selectedFeature, {tooltip: popup});
    }
  }
  cancelTooltipTimeout() {
    if (this.toolTipTimeout) {
      clearInterval(this.toolTipTimeout);
      this.toolTipTimeout = undefined;
    }
  }
  scheduleTooltip() {
    if (this.tooltipsTimeout != null) {
      this.toolTipTimeout = setInterval(() => {
        this.dismissPopover();
      }, this.tooltipsTimeout * 1000);
    }
  }
  dismissPopover() {
    clearInterval(this.toolTipTimeout);
    this.toolTipTimeout = null;
    this.previousSelectedFeature = null;
    this.isPopoverOpen = false;
    this.focusPopup = false;
    this.currentPopover = null;

    if (this.tooltipInfo && this.tooltipInfo.nativeElement) {
      this.tooltipInfo.nativeElement.innerHTML = '';
    }
    this.tooltipText = '';
    this.infoPosition = {left: '0px', top: '0px'};

    this.cdRef.detectChanges();
  }
  isContainFeature(id, assets) {
    if (!assets) { return false; }
    for (let i = 0; i < assets.length; i++) {
      const ass = assets[i];
      if (id.indexOf(ass.properties.linkAssets[0].documentId) > -1) { return true; }
    }
    return false;
  }
  showPopupClusters() {
    this.dismissPopover();
    let popover;
    if (this.divInfoCluster && this.divInfoCluster.nativeElement) {
      this.divInfoCluster.nativeElement.click();
      popover = this.divInfoCluster.nativeElement.querySelectorAll('div.popover')[0];
    }

    this.isPopupClusterOpen = true;

    if (popover && this.mapObj) {
        const lst = document.querySelectorAll('[content-exp="contentExp()"]');
        if (lst != null && lst.length > 0) {
          const item: any = lst[0];
          item.style.zIndex = this.mapObj.layerIndexTooltips;
        }
    }
  }

  resetupTooltipUI() { // 15714
    if (!this.mapObj) { return; }
    if (this.mapObj.setupTooltipUI && (typeof this.mapObj.setupTooltipUI === 'function')) {
      this.setupTooltipUI();
      this.mapObj.setupTooltipUI = null; // call one time
    }
  }

  setupTooltipUI() {
    // this.mapDiv.appendChild(this.closeTextBox);

    if (this.libName === MapLibraryName.OPEN_LAYER) {
      if (this.divInfo && this.divInfo.nativeElement) {
        this.targetMapElement.insertBefore(this.divInfo.nativeElement, this.targetMapElement.firstChild);
      }
      if (this.divInfo1 && this.divInfo1.nativeElement) {
        this.targetMapElement.insertBefore(this.divInfo1.nativeElement, this.targetMapElement.firstChild);
      }
    } else if (this.libName === MapLibraryName.GOOGLE) {
      if (!this.mapObj) { return; }
      if (this.mapObj.divCustomControl == null) {
        if (this.divInfo && this.divInfo.nativeElement) {
          this.targetMapElement.firstChild.firstChild.appendChild(this.divInfo.nativeElement);
        }
        if (this.divInfo1 && this.divInfo1.nativeElement) {
          this.targetMapElement.firstChild.firstChild.appendChild(this.divInfo1.nativeElement);
        }
      }
      else{
        this.mapObj.divCustomControl.style.zIndex = this.mapObj.layerIndexTooltips + 1;
        if (this.intervalToolTipSetup == null) {
          this.intervalToolTipSetup = setInterval(() => {
            if (this.mapObj.divCustomControl.parentElement != null) {
              if (this.divInfo && this.divInfo.nativeElement) {
                this.mapObj.divCustomControl.parentElement.appendChild(this.divInfo.nativeElement);
              }
              if (this.divInfo1 && this.divInfo1.nativeElement) {
                this.mapObj.divCustomControl.parentElement.appendChild(this.divInfo1.nativeElement);
              }
              clearInterval(this.intervalToolTipSetup);
              this.intervalToolTipSetup = null;
            } else {
              this.countIntervalTooltipSetup++;
              if (this.countIntervalTooltipSetup > 10) {
                console.log('can\'t setup tooltip because the initialize of custom control can\'t finish');
                clearInterval(this.intervalToolTipSetup);
                this.intervalToolTipSetup = null;
                if (this.divInfo && this.divInfo.nativeElement) {
                  this.targetMapElement.firstChild.firstChild.appendChild(this.divInfo.nativeElement);
                }
                if (this.divInfo1 && this.divInfo1.nativeElement) {
                  this.targetMapElement.firstChild.firstChild.appendChild(this.divInfo1.nativeElement);
                }
              }
            }
          }, 100);
        }

      }

    } else { // arcGIS
      if (!this.mapObj) { return; }
      if (this.hasCustomControl == true) {
        if (this.intervalToolTipSetup == null) {
          this.intervalToolTipSetup = setInterval(() => {
            if (this.mapObj.divCustomControl != null) {
              if (this.mapObj.divCustomControl.parentElement
                && this.mapObj.divCustomControl.parentElement.parentElement
                && this.mapObj.divCustomControl.parentElement.parentElement.parentElement) {
                  const parent3 = this.mapObj.divCustomControl.parentElement.parentElement.parentElement;
                  if (this.divInfo && this.divInfo.nativeElement) {
                    parent3.appendChild(this.divInfo.nativeElement);
                  }
                  if (this.divInfo1 && this.divInfo1.nativeElement) {
                    parent3.appendChild(this.divInfo1.nativeElement);
                  }
              } else {
                console.log('setup tooltip with element structure not as the same when implementing this logic. The z-index logic may not be the same');
                if (this.divInfo && this.divInfo.nativeElement) {
                  this.targetMapElement.firstChild.firstChild.appendChild(this.divInfo.nativeElement);
                }
                if (this.divInfo1 && this.divInfo1.nativeElement) {
                  this.targetMapElement.firstChild.firstChild.appendChild(this.divInfo1.nativeElement);
                }
              }
              clearInterval(this.intervalToolTipSetup);
              this.intervalToolTipSetup = null;
              if (this.divInfo && this.divInfo.nativeElement) {
                this.divInfo.nativeElement.style['pointer-events'] = 'visible';
              }
              if (this.divInfo1 && this.divInfo1.nativeElement) {
                this.divInfo1.nativeElement.style['pointer-events'] = 'visible';
              }
            } else {
              this.countIntervalTooltipSetup++;
              if (this.countIntervalTooltipSetup > 10) {
                console.log('can\'t setup tooltip because the initialize of custom control can\'t finish');
                clearInterval(this.intervalToolTipSetup);
                this.intervalToolTipSetup = null;
                if (this.divInfo && this.divInfo.nativeElement) {
                  this.targetMapElement.firstChild.firstChild.appendChild(this.divInfo.nativeElement);
                  this.divInfo.nativeElement.style['pointer-events'] = 'visible';
                }
                if (this.divInfo1 && this.divInfo1.nativeElement) {
                  this.targetMapElement.firstChild.firstChild.appendChild(this.divInfo1.nativeElement);
                  this.divInfo1.nativeElement.style['pointer-events'] = 'visible';
                }
              }
            }
          }, 100);
        }
      } else {
        if (this.divInfo && this.divInfo.nativeElement) {
          this.targetMapElement.firstChild.firstChild.appendChild(this.divInfo.nativeElement);
          this.divInfo.nativeElement.style['pointer-events'] = 'visible';
        }
        if (this.divInfo1 && this.divInfo1.nativeElement) {
          this.targetMapElement.firstChild.firstChild.appendChild(this.divInfo1.nativeElement);
          this.divInfo1.nativeElement.style['pointer-events'] = 'visible';
        }
      }
    }
    if (this.divInfoCluster && this.divInfoCluster.nativeElement) {
      this.targetMapElement.insertBefore(this.divInfoCluster.nativeElement, this.targetMapElement.firstChild); // 15251
    }
  }
  hasMouseStopped(evt) {
    if (!this.mapObj) { return; }
    if (!this.mapObj.showTooltip) {
      this.dismissPopover();
      // console.log(`**** not show tooltip`);
      return;
    }

    const newMouseX = (this.libName === MapLibraryName.OPEN_LAYER ? evt.originalEvent.x : evt.pixel[0] );
    const newMouseY = (this.libName === MapLibraryName.OPEN_LAYER ? evt.originalEvent.y : evt.pixel[1] );

    if ((newMouseX === this.mouseX) && (newMouseY === this.mouseY)) {
      // stopped moving
      clearInterval(this.mouseStopInterval);
      this.mouseStopInterval = null;

      if (this.libName === MapLibraryName.OPEN_LAYER) {
        this.displayFeatureInfo(this.mapObj.getEventByPixel(this.lastEvt.originalEvent));
      } else {
        this.displayFeatureInfo(evt);
      }

    }
    this.mouseX = newMouseX;
    this.mouseY = newMouseY;
  }
  mapWatchStop() {
    if (!this.mapObj) { return; }
    const mapSize = this.mapObj.getMapSize();

    if (mapSize) {
      const mapWidth = mapSize[0];
      const mapHeight = mapSize[1];
      this.mapCenter = {x: mapWidth / 2, y: mapHeight / 2};
    } else {
      console.log('Couldn\'t get size of map to enable tooltips');
    }

    this.tooltipRadioPosition = 'top'; // the position of the tooltip relative to infoPosition
    this.infoRadioPosition = {left: '0px', top: '0px'};
    this.infoPosition = {left: '0px', top: '0px'};
    this.tooltipText = '';
    this.tooltipPosition = {left: '0px', top: '0px'}; // the position of the tooltip relative to infoPosition
    if (this.tooltipInfo && this.tooltipInfo.nativeElement) {
      this.tooltipInfo.nativeElement.innerHTML = '';
    }
    this.focusPopup = false;
    this.isPopoverOpen = false;

    this.infoClusterPosition = {left: '0px', top: '0px'};
  }
  displayFeatureInfo(pixel) {

    if (this.isPopupRadioOpen || !this.mapObj) {
        return;
    }

    const obj = this.mapObj.getFeatureByPixel(pixel);

    if (obj == null) { return null; }
    const feature = obj.feature;
    if (feature == null) { return feature; }

    let shouldShow = false;
    this.pixelPopup = (this.libName === MapLibraryName.OPEN_LAYER) ? pixel : pixel.pixel;
    let tooltip = this.mapObj.getFeatureProperty(feature, 'tooltip');
    if (tooltip === null || tooltip === undefined) {
      this.getTooltipData(feature);
      tooltip = this.mapObj.getFeatureProperty(feature, 'tooltip');
    }
    if (tooltip) {
      // check popup is showing or not
      const isPopupShowed = false;

      if ((this.previousSelectedFeature == null || this.previousSelectedFeature !== feature) &&
        (!this.focusPopup || !isPopupShowed)) {

        this.cancelTooltipTimeout();

        this.tooltipText = tooltip;
        if (this.tooltipInfo && this.tooltipInfo.nativeElement) {
          this.tooltipInfo.nativeElement.innerHTML = tooltip;
        }
        this.previousSelectedFeature = feature;
        shouldShow = true;
        this.cdRef.detectChanges();
        this.setTooltipPosition(this.pixelPopup);
        this.scheduleTooltip();
      }

      if (!isPopupShowed && shouldShow) {
        this.showPopupTooltip();
      }
    }
    return feature;
  }
  setTooltipPosition(pixel) {
    if (!this.mapCenter || !this.mapCenter.x || !this.mapCenter.y) {
      this.getMapSize();
    }
    this.isToolTipScroll = false;
    if (this.tooltipInfo && this.tooltipInfo.nativeElement) {
      this.tooltipInfo.nativeElement.style.height = 'auto';
    }

    const featureLeftPos = pixel[0];
    const featureTopPos = pixel[1] ;

    this.infoPosition.left = featureLeftPos + 'px';
    this.infoPosition.top = featureTopPos + 'px';
    this.isPopoverOpen = true;

    // set the tooltip position
    let tooltipHorizontalPosition;
    let tooltipVerticalPosition;


    if (featureLeftPos < this.mapCenter.x) {
        tooltipHorizontalPosition = 'left';
    } else {
        tooltipHorizontalPosition = 'right';
    }

    if (featureTopPos < this.mapCenter.y) {
        tooltipVerticalPosition = 'bottom';
    } else {
        tooltipVerticalPosition = 'top';
    }


    let tipWidth = 0; let tipHeight = 0;
    if (this.divInfo && this.divInfo.nativeElement) {
      const divInfoPos = this.divInfo.nativeElement.getBoundingClientRect();
      tipWidth = divInfoPos.width;
      tipHeight = divInfoPos.height;
    }

    if (tipWidth === 0) { tipWidth = 276; }
    if (tipHeight === 0) { tipHeight = 68; }
    let tipPos = { left: 0, top: 0 };
    if (tooltipVerticalPosition === 'top') {
      if (tooltipHorizontalPosition === 'left') {
        tipPos = {
          left: featureLeftPos + 1,
          top: featureTopPos - tipHeight + 1
        };
      } else {// right
        tipPos = {
          left: featureLeftPos - tipWidth + 1,
          top: featureTopPos - tipHeight + 1
        };
      }
    } else {// bottom
      if (tooltipHorizontalPosition === 'left') {
        tipPos = {
          left: featureLeftPos + 1,
          top: featureTopPos + 1
        };
      } else {// right
        tipPos = {
          left: featureLeftPos - tipWidth + 1,
          top: featureTopPos + 1
        };
      }
    }
    this.infoPosition.left = tipPos.left + 'px';
    this.infoPosition.top = tipPos.top + 'px';
    this.cdRef.detectChanges();

    let height = this.mapHeight;
    let infoPosTop = tipPos.top;
    let tooltipOffsetHeight = 0;
    if (this.tooltipInfo && this.tooltipInfo.nativeElement) {
      tooltipOffsetHeight = this.tooltipInfo.nativeElement.offsetHeight;
    }
    if (tipPos.top > 0) {
      height = tipPos.top + tooltipOffsetHeight;
      infoPosTop = tipPos.top;
    } else {
      height = pixel[1] + tooltipOffsetHeight;
      infoPosTop = pixel[1];
    }
    if (height > this.mapHeight) {
      const h = this.mapHeight - pixel[1];
      if (this.tooltipInfo && this.tooltipInfo.nativeElement) {
        this.tooltipInfo.nativeElement.style.height = h + 'px';
      }
      this.isToolTipScroll = true;
      this.infoPosition.top = infoPosTop + 'px';
      this.cdRef.detectChanges();
    }
  }
  showPopupTooltip() {
    if (this.divInfo && this.divInfo.nativeElement) {
      $(this.divInfo).trigger('hover');
    }

    this.isPopoverOpen = true;
    let popover;
    if (this.divInfo && this.divInfo.nativeElement) {
      popover = $(this.divInfo.nativeElement)[0].querySelectorAll('div.popover-inner')[0];
    }
    this.currentPopover = popover;
    this.focusPopup = false;
    if (popover && this.mapObj) {
      const lst = document.querySelectorAll('[content-exp="contentExp()"]');
      if (lst != null && lst.length > 0) {
        const item: any = lst[0];
        item.style.zIndex = this.mapObj.layerIndexTooltips;
      }

      popover.style.zIndex = this.mapObj.layerIndexTooltips;
      popover.onmouseover = () => {
        this.focusPopup = true;
        this.cancelTooltipTimeout();

      };
      popover.onmouseout = () => {
        this.focusPopup = false;
        this.scheduleTooltip();
      };
    }
  }
  getMapSize() {
    if (!this.mapObj) { return; }
    const mapSize = this.mapObj.getMapSize();

    if (mapSize) {
        const mapWidth = mapSize[0];
        const mapHeight = mapSize[1];
        this.mapCenter = {x: mapWidth / 2, y: mapHeight / 2};
    } else {
        console.log('Couldn\'t get size of map to enable tooltips');
    }
  }


  isInBoxLimit(lat, lon, systemMapLimit) {
    // systemMapLimit : [ [ top, left ], [bottom, right ] ]
    const box = {
      left: systemMapLimit[0][1],
      bottom: systemMapLimit[1][0],
      right: systemMapLimit[1][1],
      top: systemMapLimit[0][0],
    }

    // (ix,iy) are its top-left
    // (ax,ay) its bottom-right
    if ( box.bottom <= lat && lat <= box.top && box.left <= lon && lon <= box.right ) {
      // Point is in bounding box
      return true;
    }
    return false
  }

  checkValidBoxWhenLoadAsset(boudingBox) {
    if (this.minZoomAsset !== 0 && this.maxZoomAsset !== 0 &&
      (boudingBox == null || boudingBox.zoom <= this.minZoomAsset
         || boudingBox.zoom > this.maxZoomAsset)) {
     console.log('invalid bounding box');
     if (this.deleteAfterMaxZoom && boudingBox.zoom > this.maxZoomAsset) {
      this.mapObj?.clearAllFeatures();
     }
     return false;
    }
    return true;
  }



  loadAsset(fromSource, isFirstLoad, params) {
    if (!this.mapObj) { return; }
    const boudingBox = this.mapObj.getBoundingBox({EPSG: this.EPSG});
    if (boudingBox == null) { return; }
    if (!this.checkValidBoxWhenLoadAsset(boudingBox)) {
      return;
    }
    if (this.currentBox != null && this.currentBox.minLon == boudingBox.minLon && this.currentBox.maxLat == boudingBox.maxLat
      && this.currentBox.maxLon == boudingBox.maxLon && this.currentBox.minLat == boudingBox.minLat) {
      console.log('don\'t load asset because the map current view port has not change');
      return;
    }
    this.currentBox = cloneDeep(boudingBox);

    const coor = [boudingBox.minLon, boudingBox.maxLat];
    const coorNext = [boudingBox.maxLon, boudingBox.minLat];


    this.lstLoadedOriginFilter = [];
    this.lstLoadedOriginFilterAfterHandlebar = {};
    // begin 15058#c57166 : 1) initialAssetLoading
    if (this.layerAssets.length > 0) {
      if (this.requestId) { clearTimeout(this.requestId); }
      this.requestId = null;
      this.isRequesting = true;

      // delete old feature from componentDefinition.layer & componentDefinition.filter
      for (let i = 1; i < this.mapObj.layerIndexFilter + 1; i++) {
        this.mapObj.clearAllFeaturesLayer(i);
      }

      this.countFinishQueries = 0;
      let layerIdx = -1;
      for (let i = 0; i < this.layerAssets.length; i++) {
        const isFilter = this.layerAssets[i].isFilter;
        const layer = this.layerAssets[i].layer;
        if (!isFilter) {
          layerIdx++;
        }

        if (layer.filter || layer.type === 'dynamic') {

          const newFilter = sclHandlebars.processHandlebars(layer.filter, null, null, null, this.contextParams);
          if (this.lstLoadedOriginFilter.indexOf(layer.filter) < 0) {
            this.lstLoadedOriginFilter.push(layer.filter);
            this.lstLoadedOriginFilterAfterHandlebar[i] = newFilter;
          }

          if (this.showTiming) {
            if (isFilter) {
              console.log(`%c from: ${fromSource}, <user_config>.filter
              start time search filter ${(new Date()).toISOString()}
              \n\t, query = ${newFilter}`, 'color:green');
            } else {
              console.log(`%c from: ${fromSource}
              , start time for all query layer ${(new Date()).toISOString()}`, 'color:green');
            }
          }

          let query = layer.filter + (isFilter ? '_filter': '_layer') + '_' + this.layerAssets[i].i;
          this.searchMultiAssetMove(fromSource, coor, coorNext, newFilter, layer.geoJsonField, layer
            , query, layer, {
              pageSize: this.pageSize,
              layerDisplayOnly: layer.layerDisplayOnly,
            }, this.loadAssetCb.bind(this, fromSource, layerIdx, isFilter, isFirstLoad));
        } else if (layer.type === 'tile') {
          this.searchMultiAssetMove(fromSource, coor, coorNext, null, layer.geoJsonField, layer
            , null, layer, {
              pageSize: this.pageSize,
              layerDisplayOnly: layer.layerDisplayOnly,
            }, this.loadAssetCb.bind(this, fromSource, layerIdx, isFilter, isFirstLoad));
        } else {
          this.countFinishQueries++;
          if (this.countFinishQueries === this.layerAssets.length) {
            if (this.showTiming) {
              if (isFilter) {
                console.log(`%c from: ${fromSource}
                end time search filter ${(new Date()).toISOString()}`, 'color:green');
              } else {
                console.log(`%c from: ${fromSource}, layer[${layerIdx}]
                  end time for all query layer ${(new Date()).toISOString()}`, 'color:green');
              }
            }
            if (this.compType === MapComponentName.SELECTED_ASSET
               && this.loadInitialMapView && typeof this.loadInitialMapView === 'function') {
                this.loadInitialMapView();
            }

          }
        }
      }
    }
    // end 15058#c57166 : 1) initialAssetLoading
  }
  loadAssetCb(fromSource, i, isFilter, isFirstLoad) {
    if (!this.mapObj) { return; }
    this.mapObj.updateSize();
    this.countFinishQueries++;
    if (this.countFinishQueries === this.layerAssets.length) {
        if (this.showTiming) {
          if (isFilter) {
            console.log(`%c from: ${fromSource}
             end time search filter ${(new Date()).toISOString()}`, 'color:green');
          } else {
            console.log(`%c from: ${fromSource}, layer[${i}]
             end time for all query layer ${(new Date()).toISOString()}`, 'color:green');
          }
        }
        if (isFirstLoad) {
          if (this.compType === MapComponentName.SELECTED_ASSET) {
            if (this.setPositionForAsset && typeof this.setPositionForAsset === 'function') {
              this.setPositionForAsset();
            }
            if (this.setSelectedAssetVisualize && typeof this.setSelectedAssetVisualize === 'function') {
              this.setSelectedAssetVisualize();
            }

          }

        }
        if (this.compType === MapComponentName.SELECTED_ASSET
          && this.loadInitialMapView && typeof this.loadInitialMapView === 'function') {
           this.loadInitialMapView();
       }

    }
  }

  loadAssetUWF(data) { // 15861
    if (!this.mapObj) { return; }
    const layer = data.layer;
    const layerKey = data.layerKey;
    const layerIndex = data.layerIndex;
    if (typeof layer.filter == 'undefined' || layer.filter === null) {
      console.log('filter is null');
      return;
    }
    if (layerIndex < 0) {
      console.log('invalid layer');
      return;
    }
    const boudingBox = this.mapObj.getBoundingBox({EPSG: this.EPSG});
    if (boudingBox == null) { return; }
    if (!this.checkValidBoxWhenLoadAsset(boudingBox)) {
      return;
    }
    const coor = [boudingBox.minLon, boudingBox.maxLat];
    const coorNext = [boudingBox.maxLon, boudingBox.minLat];

    let fromSource = 'updateWatchFields';


    if (this.requestId) { clearTimeout(this.requestId); }
    this.requestId = null;
    this.isRequesting = true;
    let newFilter;
    if (this.uwfFilterCalled.length == 0) { this.countUwfFilterDone = 0; }
    // query for the layer which has updateWatchField
    if (this.uwfFilterCalled.indexOf(layer.filter) < 0) {
      this.uwfFilterCalled.push(layer.filter);
      if (this.showTiming) {
        console.log(`%c from: ${fromSource}
         start time for all query layer ${(new Date()).toISOString()}`, 'color:green');
      }
      newFilter = sclHandlebars.processHandlebars(layer.filter, null, null, null, this.contextParams);
      this.searchMultiAssetMoveUpdate(fromSource, layerKey, layerIndex, coor, coorNext, newFilter, layer.geoJsonField
        , layer, layer.filter + '_layer_' + layerIndex, layer
        , this.loadAssetUWFLayerCb.bind(this, fromSource, layerIndex));
    }
    if (this.lstLoadedOriginFilter.indexOf(layer.filter) < 0) {
      this.lstLoadedOriginFilter.push(layer.filter);
      this.lstLoadedOriginFilterAfterHandlebar[layerKey] = newFilter;
    }

    // query for other layer
    if (this.hasResize === true) { // Note : can't see this case happens when testing but this logic should stay
      this.hasResize = false; // reset
      console.log('HAS RESIZE -> LOAD ASSET FROM UPDATE WATCH FIELD');
      this.currentBox = cloneDeep(boudingBox);

      for (let i = 0; i < this.layerAssets.length; i++) {
        const layer1 = this.layerAssets[i].layer;
        if (layer1.filter) {
          if ( this.uwfFilterCalled.indexOf(layer1.filter) > -1 ) { continue; }
          this.uwfFilterCalled.push(layer1.filter);

          // clear old asset before fetching new
          const idx = this.layerAssets[i].i; // layer index
          this.mapObj.clearAllFeaturesLayer(idx);
          const newFilter = sclHandlebars.processHandlebars(layer1.filter, null, null, null, this.contextParams);
          this.searchMultiAssetMoveUpdate(fromSource, layerKey, idx, coor, coorNext, newFilter, layer1.geoJsonField
            , layer1, layer1.filter + '_layer_' + this.layerAssets[i].i, layer1
            , this.loadAssetUWFOtherLayerCb.bind(this));
        } else {
          this.countUwfFilterDone++;
          if (this.countUwfFilterDone == this.uwfFilterCalled.length) {
            this.uwfFilterCalled = []; // reset
          }
        }
      }
    } else { // 16005
      // check which the filter has in this.lstLoadedOriginFilter
      this.currentBox = JSON.parse(JSON.stringify(boudingBox));

      // load another filter
      for (let i = 0; i < this.layerAssets.length; i++) {
        const layer1 = this.layerAssets[i].layer;
        if (layer1.filter) {
          const newFilter = sclHandlebars.processHandlebars(layer1.filter, null, null, null, this.contextParams);

          if ( (this.lstLoadedOriginFilter.indexOf(layer1.filter) > -1 || this.uwfFilterCalled.indexOf(layer1.filter) > -1 )
            &&  isEqual(this.lstLoadedOriginFilterAfterHandlebar[i], newFilter))
           {
             continue;
           }
          this.lstLoadedOriginFilter.push(layer1.filter);
          this.lstLoadedOriginFilterAfterHandlebar[i] = newFilter;

          // clear old asset before fetching new
          const idx = this.layerAssets[i].i; // layer index
          this.mapObj.clearAllFeaturesLayer(idx);

          // fetching asset

          this.searchMultiAssetMoveUpdate(fromSource, layerKey, idx, coor, coorNext, newFilter, layer1.geoJsonField
            , layer1, layer1.filter + '_layer_' + this.layerAssets[i].i, layer1
            , this.loadAssetUWFOtherLayerCb.bind(this));
        }
      }
    }
  }
  loadAssetUWFOtherLayerCb() {
    this.countUwfFilterDone++;
    if (this.countUwfFilterDone == this.uwfFilterCalled.length) {
      this.uwfFilterCalled = []; // reset
    }
  }
  loadAssetUWFLayerCb(fromSource, layerIndex) {
    if (!this.mapObj) { return; }
    this.mapObj.updateSize();
    if (this.showTiming) {
      console.log(`%c from: ${fromSource}, layer[${layerIndex}]
       end time for all query layer ${(new Date()).toISOString()}`, 'color:green');
    }
    this.countUwfFilterDone++;
    if (this.countUwfFilterDone == this.uwfFilterCalled.length) {
      this.uwfFilterCalled = []; // reset
      if (this.compType === MapComponentName.SELECTED_ASSET
        && this.loadInitialMapView && typeof this.loadInitialMapView === 'function') {
        this.loadInitialMapView();
      }

    }
  }
  setupContext() {
    return {
      document: this.document,
      account: this.contextParams.account,
      template: this.contextParams.template,
      componentDefinition: this.componentDefinition
    };
  }
  setupSearchOptions(options, field, dataSource) {
    options.dataSource =  dataSource;
    options.queryName = field.queryName;
    options.searchOfflineOnly = this.componentDefinition?.searchOptions?.searchOfflineOnly;

    return options;
  }
  searchMultiAssetMoveUpdate(fromSource, layerKey, layerIndex, coor, coorNext, filterLayer, geoJsonField, layer, query, field, cb) {
    if (layer.type === 'dynamic') {
      // this.searchWebService(layer, cb);
      this.searchWebService(
        {
          layer,
          layerDisplayOnly: layer.layerDisplayOnly,
          isRefreshFeature: null,
          asset: null,
          primaryMultiPopup: null,
          secondaryMultiPopup: null,
        }, cb);
    } else {
      let hasBoundingBox = sclUtilMapService.hasBoundingBox(layer);
      // filter new feature
      const filter = sclUtilMapService.getQueryGeo(coor, coorNext, filterLayer, geoJsonField
        , hasBoundingBox);
      if (filter) {
        let options = {
          page: 0,
          pageSize: this.pageSize,
          document: this.document,
          filter : filter,
          layerKey: layerKey,
          searchOptions: null,
          queryName: null,
          dataSource: null,
        };
        // begin 14934
        let layerFilter = options.filter;
        if (typeof layerFilter !== 'string') {
          layerFilter = JSON.stringify(options.filter);
        }
        this.updateWatchFieldsLayerKey[layerKey][layerIndex] = layerFilter; // 14934

        // end 14934

        if (!field.queryName) {
          field.queryName = this.componentDefinition?.queryName;
        }
        const dataSource = this.searchClientService.getDefaultSearchProvider(
          this.setupContext()
        );
        if (field.queryName) {
          options = this.setupSearchOptions(options, field, dataSource);
        }

        this.searchAsset(fromSource, options, geoJsonField, layer, query
          , {}, cb);
      } else {
        console.error('filter is null because filterLayer is : ', filterLayer);
        if (cb && typeof cb === 'function') {
          cb();
        }
      }


    }


  }


  async drawAsset(params) {
    const i = params.i;
    const itemData = params.itemData;
    const geoJsonField = params.geoJsonField;
    const layerIndex = params.layerIndex;
    const layer = params.layer;
    const heatmapPoints = params.heatmapPoints;
    const isFit = params.isFit;
    const customData = params.customData;
    const tooltip = (params.tooltip ? params.tooltip : layer.tooltips) ;
    const layerClone = params.layerClone;
    const layerDisplayOnly = (params.layerDisplayOnly ? params.layerDisplayOnly : layer.layerDisplayOnly);
    const isRefreshFeature = params.isRefreshFeature;
    const getAssetPoint = params.getAssetPoint; // selected-asset
    const cb = params.cb;

    let needFit = isFit;
    let obj = {
      needFit,
    }
    try {
      if (itemData[geoJsonField]) {
        if (itemData[geoJsonField].features) {
          for (let j = 0; j < itemData[geoJsonField].features.length; j++) {
            const featureData = itemData[geoJsonField].features[j];
            // DION - bit more data protection
            if (!featureData) {
              console.log('asset ' + itemData.documentId + ' has no feature data\n\t, summaryName = '
               + itemData.systemHeader.summaryName + '\n\t, asset data = ' + JSON.stringify(featureData));
              continue;
            }

            if (featureData.type === FEATURE_TYPE.FEATURE) {
              if (!featureData.geometry.coordinates) {
                console.log('2, asset ' + itemData.documentId + ' has no geometry data\n\t, summaryName = '
               + itemData.systemHeader.summaryName + '\n\t, asset data = ' + JSON.stringify(featureData));

                continue;
              }
            } else if (featureData.type === FEATURE_TYPE.GEOMETRY_COLLECTION) {
              if (
                !Array.isArray(featureData.geometries) ||
                featureData.geometries.length === 0
              ) {
                console.log('3, asset ' + itemData.documentId + ' has no geometry data\n\t, summaryName = '
               + itemData.systemHeader.summaryName + '\n\t, asset data = ' + JSON.stringify(featureData));
                continue;
              }
            }

            if (featureData.type === FEATURE_TYPE.GEOMETRY_COLLECTION) {
              for (let k = 0; k < featureData.geometries.length; k++) {
                const kFeatureData = {
                  type: FEATURE_TYPE.FEATURE,
                  geometry: featureData.geometries[k],
                  properties: featureData.properties
                };
                obj = await this.drawAFeature(i, j, obj, kFeatureData, geoJsonField
                  , getAssetPoint, itemData, layerIndex, needFit, isFit, layer
                  , customData, tooltip, layerClone, layerDisplayOnly, isRefreshFeature
                  , heatmapPoints, itemData.documentId, k.toString());
                
              }
            } else {
              obj = await this.drawAFeature(i, j, obj, featureData, geoJsonField
                  , getAssetPoint, itemData, layerIndex, needFit, isFit, layer
                  , customData, tooltip, layerClone, layerDisplayOnly, isRefreshFeature
                  , heatmapPoints, null, null);
              
            }

            if (obj === null) {
              continue;
            }

            if (i == customData.length - 1 && typeof cb === 'function') {
              // console.log(`%c DONE DRAW ALL ASSET OF THIS LAYER ${layerIndex}`, 'color:red');
              cb();
            }
          }
        }
      }
    } catch(err) {
      console.log('err : ' + err);
    }
    return obj;
  }
  async drawAFeature(i, indexFeature, obj, featureData, geoJsonField, getAssetPoint, itemData
    , layerIndex, needFit, isFit, layer, customData, tooltip, layerClone
    , layerDisplayOnly, isRefreshFeature, heatmapPoints, sharedId, indexFeatureCollection
  ) {
    try {
      let radius = null; let circleCenter = null;
      if (featureData.properties && featureData.properties.radius) {
        radius = featureData.properties.radius; // this asset is circle
        circleCenter = featureData.geometry.coordinates;
      }

      const lat = featureData.geometry.coordinates[1];
      const lon = featureData.geometry.coordinates[0];

      if (lat === '' || lon === '' || !featureData.geometry.type) {
        return null;
      }
      let addressField = geoJsonField;
      if (this.compType == MapComponentName.SELECTED_ASSET
          && this.primaryAssetAddressField) {
        addressField = this.primaryAssetAddressField;
      }
      let asset = null;
      if (getAssetPoint && typeof getAssetPoint === 'function') { // sc-selected-asset
        asset = getAssetPoint(itemData, this.componentDefinition, MapSelectAssetType.PRIMARY,
          addressField, this.componentDefinition.primaryAssetAddressSelection);
      }

      // var id = _geoJsonField + '_' + itemData.documentId;//will make bug name is empty after document saved
      const dataId = itemData.documentId;
      let id = `${dataId}_${indexFeature}_${layerIndex}`;
      if (typeof indexFeatureCollection === 'string') {
        id = `${id}_${indexFeatureCollection}`;
      }
      const type = featureData.geometry.type;
      const url = 'form/' + dataId;
      let name = '';
      if ( itemData.systemHeader && itemData.systemHeader.summaryName) {
          name = itemData.systemHeader.summaryName;
      }
      // heat map
      needFit = isFit;
      const label = { labelText : layer.labelText, labelTextAlign : layer.labelTextAlign
        , labelTextBaseline : layer.labelTextBaseline, labelColor : layer.labelColor
        , labelOutlineColor : layer.labelOutlineColor, labelOutlineWidth : layer.labelOutlineWidth
        , labelOffsetX : layer.labelOffsetX, labelOffsetY : layer.labelOffsetY, labelPlacement : layer.labelPlacement
        , labelMaxAngle : layer.labelMaxAngle, labelOverflow : layer.labelOverflow
        , labelRotationWithView : layer.labelRotationWithView, labelRotation : layer.labelRotation
        , labelPadding : layer.labelPadding, labelFont : layer.labelFont, labelFontWeight : layer.labelFontWeight
        , labelFontSize : layer.labelFontSize, labelDisplayZoom: layer.labelDisplayZoom};

      const handlebarsContext = {
        results: customData,
        resultsCount: customData.length,
        resultsIndex: i,
        queryResultDocument: itemData
      };

      let rotation = sclUtilMapService.processLayerRotation(layer, layerIndex
        , this.componentDefinition, this.contextParams, handlebarsContext);


      let primaryMultiPopup = null;
      let secondaryMultiPopup = null;
      if (this.compType == MapComponentName.SELECTED_ASSET) { // selected-asset
        primaryMultiPopup = name;
        secondaryMultiPopup = name;
        if (this.popupAssetSelectionPrimaryText) {
          primaryMultiPopup = sclHandlebars.processHandlebars(this.popupAssetSelectionPrimaryText, handlebarsContext, null, null, this.contextParams, null);
        }
        if (this.popupAssetSelectionSecondaryText) {
          secondaryMultiPopup = sclHandlebars.processHandlebars(this.popupAssetSelectionSecondaryText, handlebarsContext, null, null, this.contextParams, null);
        }
      }


      obj = await this.draw1Asset({
        handlebarsContext,
        layer,
        itemData,
        tooltip,
        layerClone,
        id,
        docId: dataId,
        name,
        type,
        featureData,
        label,
        pImageFileNo: layer.imageFileNo,
        clusterImageFileNo: layer.clusterImageFileNo,
        layerDisplayOnly,
        url,
        layerIndex,
        isRefreshFeature,
        rotation,
        scale: 1,
        idCache: 0,
        radius,
        circleCenter,
        heatmapPoints,
        asset, // selected-asset
        primaryMultiPopup, // selected-asset
        secondaryMultiPopup, // selected-asset
        needFit, // address-map
        sharedId: sharedId
      });
    } catch (error) {
      console.log(`drawAFeature error at documentId: ${itemData.documentId}: `, error);
    }
    
    
    return obj;
  }
  isBase64(str) {
    const base64Regex = /^(data:\w+\/[a-zA-Z+\-]+;base64,)?([A-Za-z0-9+/]+={0,2})$/;
    return base64Regex.test(str);
  }
  async draw1Asset(params) {
    if (!this.mapObj) { return; }
    const handlebarsContext = params.handlebarsContext;
    const layer = params.layer;
    const itemData = params.itemData;
    const tooltip = params.tooltip;
    let layerClone = params.layerClone;
    const id = params.id;
    const docId = params.docId;
    const name = params.name;
    let type = params.type;
    const featureData = params.featureData;
    let label = params.label;
    const pImageFileNo = params.pImageFileNo;
    const clusterImageFileNo = params.clusterImageFileNo;
    const layerDisplayOnly = params.layerDisplayOnly;
    const url = params.url;
    const layerIndex = params.layerIndex;
    const isRefreshFeature = params.isRefreshFeature;
    const rotation = params.rotation;
    const scale = params.scale;
    const idCache = params.idCache;
    const radius = params.radius;
    const circleCenter = params.circleCenter;

    const heatmapPoints = params.heatmapPoints;
    const asset = params.asset;
    const primaryMultiPopup = params.primaryMultiPopup;
    const secondaryMultiPopup = params.secondaryMultiPopup;
    const needFit = params.needFit;
    const sharedId = params.sharedId;

    let imageFileNo = sclHandlebars.processHandlebars(pImageFileNo, handlebarsContext, null, null, this.contextParams, null);
    if (this.disableHandlebars === true) { // 15250
      imageFileNo = null;
    }
    if (layer.type === 'cluster' && (typeof clusterImageFileNo !== 'undefined' && clusterImageFileNo.trim() !== '') ) {
      imageFileNo = sclHandlebars.processHandlebars(clusterImageFileNo, handlebarsContext, null, null, this.contextParams, null);
    }
    if (this.libName === MapLibraryName.OPEN_LAYER) {
      if (imageFileNo.trim().length === 0) {
        imageFileNo = SclMapConstantService.MAP_MARKER;
      }
      try {
        imageFileNo = await this.getIcon(imageFileNo);
        // if (this.isShowLogDebugIconUrl) {
        //   console.log('**** after waiting getIcon, imageFileNo = ' + imageFileNo);
        // }
        
      } catch (err) {
        console.log('error getFileResource : ' + err.message);
      }
    }
    let centerPoint = null;
    if (layer.type !== 'heatmap') {
      if (layer.type === 'cluster' && type !== MapDrawType.POINT) {
        centerPoint = sclUtilMapService.getCenterOfGeometry(featureData.geometry.coordinates, type);
      }
      let imageUrl = imageFileNo;
      // if (this.isShowLogDebugIconUrl) {
      //   console.log('**** imageUrl first assigned = ' + imageUrl);
      // }
      
      if (imageUrl) {
        if (this.isBase64(imageUrl) == false) {
          imageUrl = sclUtilMapService.handleImageFileNo(imageUrl);
          imageFileNo = sclUtilMapService.handleImageFileNo(imageFileNo);

          // if (this.isShowLogDebugIconUrl) {
          //   console.log('**** imageUrl add api/getFile = ' + imageUrl);
          // }
        }
        await this.cacheImage(imageUrl);
        if (this.compType === MapComponentName.ADDRESS_MAP) {
          const iconIndex = this.mapObj.cacheImageUrls.indexOf(imageUrl);
          let strBase64 = this.mapObj.cacheImageBase64s[iconIndex];
          if (iconIndex > -1 && (rotation && rotation != 0)
           || (params.scale != 1)) {
            const isFlip = (scale < 0 ? true : false);
            const infoId = imageUrl + '#' + rotation + '#' + scale + '#' + isFlip;
            const infoIndex = this.mapObj.cacheImageModifiedInfo.indexOf(infoId);
            if (infoIndex < 0) {
              await this.modifyImage(strBase64, rotation, scale, isFlip, infoId);
            }
          }
        }
      }
    }
    // sc-selected-asset
    if (this.compType == MapComponentName.SELECTED_ASSET
      && this.featureCollections && this.featureCollections.features
       && Array.isArray(this.featureCollections.features)
       && this.featureCollections.features.length > 0) {
      for (let k = 0; k < this.featureCollections.features.length; k++) {
        const asset = this.featureCollections.features[k];
        if (!asset.properties || !asset.properties.type) { continue; }
        const type = asset.properties.type;
        if (type !== MapSelectAssetType.PRIMARY && type !== MapSelectAssetType.SECONDARY) {
          continue;
        }
        let fId = id;
        if (id.indexOf('_') > -1) { fId = fId.split('_')[0]; }
        if (fId == asset.properties.linkAssets[0].documentId) {
          let isExisted = false;
          for (let m = 0; m < this.visualizeSelectedAsset.length; m++) {
            if (this.visualizeSelectedAsset[m].id == id) {
              isExisted = true;
              break;
            }
          }
          if (!isExisted) {
            this.visualizeSelectedAsset.push({id, handlebarsContext});
          }
          break;
        }
      }

      // update icon for primary/secondary asset
      await this.setSelectedAssetVisualize();
    }

    if (type === MapDrawType.POINT) {
      if (this.systemMapLimit) {
        if (featureData && featureData.geometry && featureData.geometry.coordinates) {
          const lon = featureData.geometry.coordinates[0];
          const lat = featureData.geometry.coordinates[1];
          const isValid = this.isInBoxLimit(lat, lon, this.systemMapLimit);
          if (!isValid) {
            console.log(`*** point is out of systemMapLimit, lon: ${lon}, lat: ${lat}, id: ${docId}`);
          }
        } else {
          console.log(`invalid asset location data, id: ${docId}`);
        }
      }

      this.countAssetPoint++;
    }



    if (radius && this.libName === MapLibraryName.GOOGLE) {
      // convert to polygon
      featureData.properties.centerPoint = featureData.geometry.coordinates;
      const coords = sclUtilMapService.circleToPolygon(featureData.geometry.coordinates, radius);
      featureData.geometry.coordinates = coords;
      type = MapDrawType.POLYGON;
      featureData.geometry.type = type;

    }

    const iRelatedAsset: any = {};
    for (const field in this.relatedAsset) {
      if (this.relatedAsset.hasOwnProperty(field)) {
        const fieldAsset = this.relatedAsset[field];
        // iRelatedAsset[field] = fieldAsset;
        if (itemData.hasOwnProperty(fieldAsset) && itemData[fieldAsset]) {
          iRelatedAsset[field] = itemData[fieldAsset];
        }
      }
    }


    if (this.disableHandlebars === true) { // 15250
      label = null;
    } else { // if label has handlebars syntax then log says error
      if (label) {
        label = sclUtilMapService.processHandlebarsOnLabel(this.componentDefinition, this.contextParams, label,
          handlebarsContext, layer, layerIndex, idCache);
      }
    }

    let pTooltip = '';
    if (this.compType == MapComponentName.ADDRESS_MAP && tooltip && this.getToolTips
       && typeof this.getToolTips === 'function') {
      pTooltip = this.getToolTips(tooltip, handlebarsContext);
    }

    let color = layer.color;
    if (this.disableHandlebars === false) { // 15250
      if (color) {
        color = sclHandlebars.processHandlebars(layer.color, handlebarsContext, null, null, this.contextParams, null);
      }
    }

    let anchor = layer.imageAnchor ? layer.imageAnchor : this.defaultImageAnchor;  // Anchor format confuses handlebars
    if (this.disableHandlebars === true) { // 15250
      layerClone.lineCap = null;
      layerClone.lineWidth = null;
      layerClone.lineDash = null;
      layerClone.fill = null;
      layerClone.fillOpacity = null;
    } else {
      anchor = sclUtilMapService.processHandlebarsOnVisualItem(this.componentDefinition, this.contextParams,
          layer.imageAnchor, layer.imageAnchorHandlebars, handlebarsContext, 'array', null);
      if (!anchor && layer.imageAnchor) { anchor = layer.imageAnchor; }

      layerClone = sclUtilMapService.processHandlebarsOnLayer(this.componentDefinition, this.contextParams,
          layerClone, handlebarsContext, layer, layerIndex);
    }


    // heat map
    let fea;
    let fData;
    if (layer.type === 'heatmap') {
      this.createHeatMapData(featureData.geometry.coordinates, type, itemData[layer.magnitudeField]
          , (this.libName === MapLibraryName.GOOGLE ? true : false ), { id: itemData.documentId, name: name
            , heatmapPoints: heatmapPoints });
    } else {
      const obj = this.createAndAddFeature(fea, fData, id, featureData, type, imageFileNo, name
        , color, layerDisplayOnly, anchor, url, layerClone, pTooltip
        , label, layerIndex, centerPoint, rotation, scale, docId, radius
        , circleCenter, iRelatedAsset, primaryMultiPopup, secondaryMultiPopup
        , asset, handlebarsContext, itemData, isRefreshFeature, sharedId);
      fea = obj.fea;
      fData = obj.fData;
    }

    return {needFit, fea, fData, label};
  }


  createAndAddFeature(fea, fData, id, featureData, type, imageFileNo, name
    , color, layerDisplayOnly, anchor, url, layerClone, pTooltip
    , label, layerIndex, centerPoint, rotation, scale, docId, radius
    , circleCenter, iRelatedAsset, primaryMultiPopup, secondaryMultiPopup
    , asset, handlebarsContext, itemData, isRefreshFeature, sharedId) {
    

    fea = this.mapObj.getFeatureById(id);
    
    fData = {
      featureData,
      type,
      imageFileNo,
      name,
      id,
      color,
      layerDisplayOnly,
      anchor,
      url,
      layerClone,
      tooltip: pTooltip,
      label,
      layer: cloneDeep(layerClone),
      layerIndex,
      centerPoint,
      rotation,
      scale,
      docId,
      radius,
      circleCenter,
      iRelatedAsset,
      primaryMultiPopup,
      secondaryMultiPopup,
      asset,
      handlebarsContext,
      itemData,
      sharedId,
    };

    if ((this.compType == MapComponentName.SELECTED_ASSET
       || this.compType == MapComponentName.STREET_ADDRESS
       || this.compType == MapComponentName.BOUNDARY)
        && this.createFeature && typeof this.createFeature === 'function') {
      const feature = this.createFeature(fData);
    }
    if (this.compType == MapComponentName.ADDRESS_MAP
       && this.createNewFeature && typeof this.createNewFeature === 'function'
     && this.updateExistedFeature && typeof this.updateExistedFeature === 'function') {
      if (!fea) {
        this.createNewFeature(fData);
      } else {
        this.updateExistedFeature(fea, label, fData, isRefreshFeature);
      }
    }
    return {fea, fData};
  }

  checkValidQuery(options) {
    // 14934
    if ( (typeof options.layerKey !== 'undefined' && !this.checkLayerKey(options.layerKey, options.filter)) ) {
      return false;
    }
    return true;
  }
  searchWebService(params, cb) {
    const layer = params.layer;
    const layerDisplayOnly = params.layerDisplayOnly;
    const isRefreshFeature = params.isRefreshFeature;
    const count = params.count;
    const isFit = params.isFit;
    // sc-selected-asset
    const asset = params.asset;
    const primaryMultiPopup = params.primaryMultiPopup;
    const secondaryMultiPopup = params.secondaryMultiPopup;

    let layerIndex = -1;
    for (let li = 0; li < this.layerAssets.length; li++) {
      if (this.layerAssets[li].layer.filter === layer.filter
         && this.layerAssets[li].layer.type === layer.type ) {
          layerIndex = this.layerAssets[li].i;
          break;
      }
    }
    if (layerIndex < 0) {
      console.log('invalid layerIndex of layer.filter = ' + layer.filter);
      if (cb && typeof cb === 'function') {
        cb();
      }
      return;
    }
    const newFilter = sclHandlebars.processHandlebars(layer.filter, null, null, null, this.contextParams);

    const funcName = layer.webServiceFunctionName;
    const webServiceName = layer.webServiceDocumentName;
    const p = {
      functionName: funcName,
      componentDocumentName: webServiceName,
      functionParameters: [newFilter, null, null, null]
    };

    //
    this.httpClient.post('api/execute', p).subscribe( (customData: any) => {
      if (customData && customData.length > 0) {
        const layerClone = cloneDeep(layer);

        let heatmapPoints = (typeof layer.heatmapPoints === 'undefined' || layer.heatmapPoints === null) ? 'Center' : layer.heatmapPoints ;
        if (heatmapPoints !== 'Points') {
          heatmapPoints = 'Center';
        }
        let countDrawed = 0;
        customData.forEach(async (item, i) => {
          if (item && item.status == 1) {
            const itemData = item.result;
            const data = sclUtilMapService.processDynamicLayerData(layer, itemData, i, layerIndex, customData, item.vehicle);

            if (this.disableHandlebars === true) { // 15250
              data.label = null;
            } else { // if label has handlebars
              if (data.label.labelText) {
                data.label.labelText = sclHandlebars.processHandlebars(data.label.labelText, data.handlebarsContext
                  , null, null, this.contextParams,
                    { handlebarsTemplateName: `${layer.name}_${layerIndex}_${data.label.labelText}_labelText` });
              }
              data.label = sclUtilMapService.processHandlebarsOnLabel(this.componentDefinition, this.contextParams, data.label,
                data.handlebarsContext, layer, layerIndex, data.id);
            }

            const obj = await this.draw1Asset({
              handlebarsContext: data.handlebarsContext,
              layer,
              i,
              itemData: data.item,
              tooltip: data.tooltip,
              layerClone,
              id: data.id,
              docId: data.id,
              name: data.name,
              type: MapDrawType.POINT,
              featureData: data.item,
              label: data.label,
              pImageFileNo: data.imageFileNo,
              clusterImageFileNo: null,
              layerDisplayOnly,
              url: data.url,
              layerIndex,
              dataId: data.dataId,
              isRefreshFeature,
              rotation: data.rotation,
              scale: data.scale,
              idCache: data.id,
              radius: null,
              circleCenter: null,
              heatmapPoints,
              asset, // selected-asset
              primaryMultiPopup, // selected-asset
              secondaryMultiPopup, // selected-asset

            });
            countDrawed++;
            if (countDrawed == customData.length) {
              if (this.compType == MapComponentName.ADDRESS_MAP) {
                this.finishSearchAsync(count, false, isFit, layer, layerIndex, cb);
              } else if (this.compType == MapComponentName.SELECTED_ASSET) {
                if (cb && typeof cb === 'function') {
                  cb();
                }
              }

            }
          } else {
            if (item && item.result) {
              console.log(item.result.error);
              console.log(item.result.errorDetails);
            }
            if (item && item.error) {
              console.log(item.error);
              console.log(item.errorDetails);
            }

            countDrawed++;
            // console.log('draw1Asset done, countDrawed = ' + countDrawed + ', total = ' + customData.length);
            if (countDrawed == customData.length) {
              if (this.compType == MapComponentName.ADDRESS_MAP) {
                this.finishSearchAsync(count, false, isFit, layer, layerIndex, cb);
              } else if (this.compType == MapComponentName.SELECTED_ASSET) {
                if (cb && typeof cb === 'function') {
                  cb();
                }
              }
            }
          }

        });
      } else {
        if (this.compType == MapComponentName.ADDRESS_MAP) {
          this.finishSearchAsync(count, false, isFit, layer, layerIndex, cb);
        } else if (this.compType == MapComponentName.SELECTED_ASSET) {
          if (cb && typeof cb === 'function') {
            cb();
          }
        }
      }
    }, (err) => {
      console.error('error query current location :');
      console.error(err);
      if (this.compType == MapComponentName.ADDRESS_MAP) {
        this.finishSearchAsync(count, false, isFit, layer, layerIndex, cb);
      } else if (this.compType == MapComponentName.SELECTED_ASSET) {
        if (cb && typeof cb === 'function') {
          cb();
        }
      }
    });
  }
  loadMapTiles(params, cb) {
    const layer = params.layer;
    const layerDisplayOnly = params.layerDisplayOnly;
    const isRefreshFeature = params.isRefreshFeature;
    const count = params.count;
    const isFit = params.isFit;
    // sc-selected-asset
    const asset = params.asset;
    const primaryMultiPopup = params.primaryMultiPopup;
    const secondaryMultiPopup = params.secondaryMultiPopup;

    let layerIndex = -1;
    for (let li = 0; li < this.layerAssets.length; li++) {
      if (this.layerAssets[li].layer.filter === layer.filter
         && this.layerAssets[li].layer.type === layer.type ) {
          layerIndex = this.layerAssets[li].i;
          break;
      }
    }
    if (layerIndex < 0) {
      console.log('invalid layerIndex of layer.filter = ' + layer.filter);
      if (cb && typeof cb === 'function') {
        cb();
      }
      return;
    }

    //
    this.httpClient.get(layer.url).subscribe( (customData: any) => {
      if (customData && customData.features && customData.features.length > 0) {
        const layerClone = cloneDeep(layer);

        let heatmapPoints = (typeof layer.heatmapPoints === 'undefined' || layer.heatmapPoints === null) ? 'Center' : layer.heatmapPoints ;
        if (heatmapPoints !== 'Points') {
          heatmapPoints = 'Center';
        }
        let countDrawed = 0;
        customData = customData.features;
        customData.forEach(async (data, i) => {
          if (data.properties) {
            for (let key in data.properties) {
              data[key] = data.properties[key];
            }
            delete data.properties;
          }
          if (!data.handlebarsContext) {
            data.handlebarsContext = {
              results: customData,
              resultsCount: customData.length,
              resultsIndex: i,
              queryResultDocument: data
            };
          }
          if (this.disableHandlebars === true) { // 15250
            data.label = null;
          } else { // if label has handlebars
            if (data.label) {
              if (data.label.labelText) {
                data.label.labelText = sclHandlebars.processHandlebars(data.label.labelText, data.handlebarsContext
                  , null, null, this.contextParams,
                    { handlebarsTemplateName: `${layer.name}_${layerIndex}_${data.label.labelText}_labelText` });
              }
              data.label = sclUtilMapService.processHandlebarsOnLabel(this.componentDefinition, this.contextParams, data.label,
                data.handlebarsContext, layer, layerIndex, data.id);
            }

          }

          const obj = await this.draw1Asset({
            handlebarsContext: data.handlebarsContext,
            layer,
            i,
            itemData: data,
            tooltip: data.tooltip,
            layerClone,
            id: data.id,
            docId: data.id,
            name: data.name,
            type: data.geometry.type,
            featureData: data,
            label: data.label,
            pImageFileNo: data.imageFileNo,
            clusterImageFileNo: null,
            layerDisplayOnly,
            url: data.url,
            layerIndex,
            dataId: data.id,
            isRefreshFeature,
            rotation: data.rotation,
            scale: data.scale,
            idCache: data.id,
            radius: null,
            circleCenter: null,
            heatmapPoints,
            asset, // selected-asset
            primaryMultiPopup, // selected-asset
            secondaryMultiPopup, // selected-asset

          });
          countDrawed++;
          if (countDrawed == customData.length) {
            if (this.compType == MapComponentName.ADDRESS_MAP) {
              this.finishSearchAsync(count, false, isFit, layer, layerIndex, cb);
            } else if (this.compType == MapComponentName.SELECTED_ASSET) {
              if (cb && typeof cb === 'function') {
                cb();
              }
            }

          }

        });
      } else {
        if (this.compType == MapComponentName.ADDRESS_MAP) {
          this.finishSearchAsync(count, false, isFit, layer, layerIndex, cb);
        } else if (this.compType == MapComponentName.SELECTED_ASSET) {
          if (cb && typeof cb === 'function') {
            cb();
          }
        }
      }
    }, (err) => {
      console.error('error query current location :');
      console.error(err);
      if (this.compType == MapComponentName.ADDRESS_MAP) {
        this.finishSearchAsync(count, false, isFit, layer, layerIndex, cb);
      } else if (this.compType == MapComponentName.SELECTED_ASSET) {
        if (cb && typeof cb === 'function') {
          cb();
        }
      }
    });


  }
  getHandlerValue(data) {
    const qualityRegex = /{{{?(.*?)?[a-z]+.[a-z]*}?}}/g;
    let matches;
    const qualities = [];

    while (matches = qualityRegex.exec(data)) {
      const match0 = matches[0];
      const item = match0.replace('{{{', '').replace('}}}', '');
      qualities.push(item);
    }

    return qualities;
  }
  // 15358: dexie query and other search provider
  getDataWithSearchProvider(dataResult) {
    let data = {
      data: [],
      total: 0,
      isOtherSearch: false
    };
    const isOtherSearch = (dataResult?.searchProvider && dataResult?.searchProvider !== 'elastic');
    if (isOtherSearch) {
      data.data = dataResult?.data;
      data.total = dataResult?.total ? dataResult?.total: dataResult?.data?.length;
    } else {
      data.data = dataResult?.data?.hits?.hits;
      data.total = dataResult?.data?.hits?.total;
    }
    data.isOtherSearch = isOtherSearch;
    return data;
  }
  searchMultiAssetMove(fromSource, coor, coorNext, filterLayer, geoJsonField
    , layer, query, field, params, cb) {

    if (layer.type === 'dynamic') {
      this.searchWebService(
        {
          layer,
          layerDisplayOnly: layer.layerDisplayOnly,
          isRefreshFeature: null,
          asset: null,
          primaryMultiPopup: null,
          secondaryMultiPopup: null,
        }, cb);
    } else if (layer.type === 'tile') {
      this.loadMapTiles({layer}, cb);
    } else {
      // filter new feature
      let hasBoundingBox = sclUtilMapService.hasBoundingBox(layer);
      const filter = sclUtilMapService.getQueryGeo(coor, coorNext, filterLayer, geoJsonField
        , hasBoundingBox);

      if (filter && filter !== 'null') {
        let options = {
          page: 0,
          pageSize: this.pageSize,
          document: this.document,
          filter,
          searchOptions: null,
          queryName: null,
          dataSource: null,
        };


        if (!field.queryName) {
          field.queryName = this.componentDefinition?.queryName;
        }
        const dataSource = this.searchClientService.getDefaultSearchProvider(
          this.setupContext()
        );
        if (field.queryName) {
          options = this.setupSearchOptions(options, field, dataSource);
        }

        this.searchAsset(fromSource, options, geoJsonField, layer, query,
          {}, cb);
      } else {
        console.error('filter is null because filterLayer is : ', filterLayer);
        if (cb && typeof cb === 'function') {
          cb();
        }
      }
    }
  }
  searchAsset(fromSource, options, geoJsonField, layer, query
    , params, cb) {

    this.loadAssetCounter++;
    const assetField = this.componentDefinition;
    let sf;
    let i;
    if (!options.filter) {
      if (cb && typeof cb === 'function') {
        cb();
      }
      return;
    }
    if (options.filter === '') {
      if (cb && typeof cb === 'function') {
        cb();
      }
      return;
    }
    options.sourceFilter = [geoJsonField, 'documentId', 'systemHeader.summaryName'];
    if (this.primaryAssetAddressField) {
      options.sourceFilter.push(this.primaryAssetAddressField);
    }
    if (this.primaryAssetGeometryField) {
      options.sourceFilter.push(this.primaryAssetGeometryField);
    }
    if (this.relatedAssetQuery.length > 0) {
      for (i = 0; i < this.relatedAssetQuery.length; i++) {
        if (options.sourceFilter.indexOf(this.relatedAssetQuery[i]) < 0) {
          options.sourceFilter.push(this.relatedAssetQuery[i]);
        }
      }
    }

    // parsing of tooltips and labelText are retained for backwards compatability.
    if (typeof layer.tooltips !== undefined && layer.tooltips !== null && layer.tooltips !== undefined) {
      sf = this.getHandlerValue(layer.tooltips);
      if (sf.length > 0) {
        for (i = 0; i < sf.length; i++) {
          if (options.sourceFilter.indexOf(sf[i]) < 0) {
            options.sourceFilter.push(sf[i]);
          }
        }
      }
    }

    if (typeof assetField.tooltips !== undefined && assetField.tooltips !== null && assetField.tooltips !== undefined) {
      sf = this.getHandlerValue(assetField.tooltips);
      if (sf.length > 0) {
        for (i = 0; i < sf.length; i++) {
          if (options.sourceFilter.indexOf(sf[i]) < 0) {
            options.sourceFilter.push(sf[i]);
          }
        }
      }
    }
    if (layer.labelText) {
      sf = this.getHandlerValue(layer.labelText);
      if (sf.length > 0) {
        for (i = 0; i < sf.length; i++) {
          if (options.sourceFilter.indexOf(sf[i]) < 0) {
            options.sourceFilter.push(sf[i]);
          }
        }
      }
    }
    if (layer.labelTextHandlebars) {
      sf = this.getHandlerValue(layer.labelTextHandlebars);
      if (sf.length > 0) {
        for (i = 0; i < sf.length; i++) {
          if (options.sourceFilter.indexOf(sf[i]) < 0) {
            options.sourceFilter.push(sf[i]);
          }
        }
      }
    }

    // Adding manual addition of fields to retrieve in queries to handle complex handlebar requirements
    // supported for overall component in root config
    if (typeof assetField.additionalQueryFields !== undefined && assetField.additionalQueryFields !== null &&
      assetField.additionalQueryFields !== undefined) {
      sf = assetField.additionalQueryFields;
      if (sf.length > 0) {
        for (i = 0; i < sf.length; i++) {
          if (options.sourceFilter.indexOf(sf[i]) < 0) {
            options.sourceFilter.push(sf[i]);
          }
        }
      }
    }

    // Supported for individual layer
    if (typeof layer.additionalQueryFields !== undefined && layer.additionalQueryFields !== null &&
      layer.additionalQueryFields !== undefined) {
      sf = layer.additionalQueryFields;
      if (sf.length > 0) {
        for (i = 0; i < sf.length; i++) {
          if (options.sourceFilter.indexOf(sf[i]) < 0) {
            options.sourceFilter.push(sf[i]);
          }
        }
      }
    }
    console.log('Layer search SourceFilter is : ' + options.sourceFilter);

    const layerClone = cloneDeep(layer);

    let heatmapPoints = (typeof layer.heatmapPoints === 'undefined' || layer.heatmapPoints === null) ? 'Center' : layer.heatmapPoints ;
    if (heatmapPoints !== 'Points') {
      heatmapPoints = 'Center';
    }
    this.searchPagingAsync(fromSource, options,
      {
        geoJsonField,
        layer,
        query,
        layerClone,
        heatmapPoints,
      }, cb);

  }
  searchPagingAsync(fromSource, options, params, cb) {


    const query = params.query;
    const layer = params.layer;
    let canFetchMore = false;
    let layerIndex = -1;
    let queryName = '';
    for (let li = 0; li < this.layerAssets.length; li++) {
      if (this.layerAssets[li].query === query && this.layerAssets[li].layer.type === layer.type ) {
          layerIndex = this.layerAssets[li].i;
          queryName = this.layerAssets[li].layer.queryName;
          this.layerAssets[li].currentFilter = options.filter; // update current filter for layer index
          break;
      }
    }
    if (layerIndex < 0) {
      console.info('layerIndex is invalid');
      if (cb && typeof cb === 'function') {
        cb();
      }
    } else {
      const startTimeRequest: any = new Date();
      if (this.showTiming) {
        console.log(` from: ${fromSource}, layer[${layerIndex}]
           start time request asset = ${startTimeRequest.toISOString()}
           \n\t, query = ${options.filter}
           \n\t, queryName = ${queryName}`);
      }
      this.searchClientService.search(options).then((dataResult: any) => {
        if (this.showTiming) {
          const endTimeRequest: any = new Date();
          const totalTimeRequest: any = (endTimeRequest - startTimeRequest) / 1000;
          console.log(` from: ${fromSource}, layer[${layerIndex}]
            end time return asset = ${endTimeRequest.toISOString()}
            \n\t, start time = ${startTimeRequest.toISOString()}
            \n\t, total time = ${totalTimeRequest} (seconds)`);
        }
        let validQuery = false;
        for (let q = 0; q < this.layerAssets.length; q++) {
          if (isEqual(this.layerAssets[q].currentFilter, options.filter)
             && this.layerAssets[q].i == layerIndex) {
            validQuery = true;
            break;
          }
        }
        if (!validQuery) {
          console.log('Get data of invalid filter, layerIndex = ' + layerIndex + '\n\t, filter = ' + options.filter);
          if (cb && typeof cb === 'function') { cb(); }
        } else {
          let data = this.getDataWithSearchProvider(dataResult);
          if (data.data.length > 0) {
            let resultCount = this.pageSize;
            if (this.pageSize > data.data.length) {
              resultCount = data.data.length;
            }
            const remain = data.total - resultCount;
            if (this.showTiming) {
              console.log(`%c fromSource: ${fromSource}, resultCount = ${resultCount}
               layer[${layerIndex}]
               \n\t, total = ${data.total}
               \n\t, remain = ${remain}`, 'color:cyan');
            }

            params.layerIndex = layerIndex;
            params.options = options;

            if (this.asyncDrawAsset) {
              this.resultSearchPagingAsync(fromSource, this.parseDataAsync.bind(this), dataResult, params, remain
              , this.pageSize, canFetchMore, layer, layerIndex, options, cb);
            } else {
              this.resultSearchPagingAsync(fromSource, this.parseData.bind(this), dataResult, params, remain
              , this.pageSize, canFetchMore, layer, layerIndex, options, cb);
            }

          } else {
            canFetchMore = false;
            if (this.showTiming) {
              console.log(`%c from: ${fromSource}, layer[${layerIndex}]
               request asset return NO DATA`, 'color:cyan');
            }
            this.finishSearch(canFetchMore, layer, layerIndex, cb);
          }
        }
      }, (err) => {
        console.error('error in Selected Asset search:' + err);
        console.error('|===> error filter = ' + options.filter);
        if (this.showTiming) {
          const endTimeRequest = new Date();
          console.log(` from: ${fromSource}, layer[${layerIndex}]
           end time return asset error = ${endTimeRequest.toISOString()}`);
        }
        if (cb && typeof cb === 'function') { cb(); }
      });
    }

  }

  parseDataAsync(data, params, cb) {
    const dataWithProviders = this.getDataWithSearchProvider(data); // 15358
    const customData = dataWithProviders.data; // 15358 // data.data.hits.hits;
    const isOtherSearch = dataWithProviders.isOtherSearch;
    const geoJsonField = params.geoJsonField;
    const layer = params.layer;
    const query = params.query;
    const layerIndex = params.layerIndex;
    const layerClone = params.layerClone;
    const heatmapPoints = params.heatmapPoints;

    if (customData && customData.length > 0 && layerIndex > -1) {
        const asyncIterable = {
            index: 0,
            len: customData.length,
            [Symbol.asyncIterator]() {
                return {
                    current: this.index,
                    last: this.len,
                    next() {
                        if (this.current < this.last) {
                            const itemData = (isOtherSearch ? customData[this.current]: customData[this.current]._source);
                            
                            this.mapFunc.drawAsset({
                              i: this.current,
                              itemData,
                              geoJsonField,
                              layerIndex,
                              layer,
                              heatmapPoints,
                              customData,
                              layerClone,
                              getAssetPoint: this.getAssetPoint.bind(this),
                              popupAssetSelectionPrimaryText: this.popupAssetSelectionPrimaryText,
                              popupAssetSelectionSecondaryText: this.popupAssetSelectionSecondaryText,
                            });
                            return Promise.resolve({ value: this.current++, done: false });
                        }
                        if (cb && typeof cb === 'function') {
                            cb();
                        }
                        return Promise.resolve({ done: true });
                    }
                };
            }
        };

        async function main() {
            // for await(const num of asyncIterable){
            //     // console.log('num = ' + num);
            // }
        }
        main()
        .then(r => {
            // console.log(r);
        })
        .catch(err => console.log(err));
    } else {
        if (cb && typeof cb === 'function') {
            cb();
        }
    }
  }
  parseData(data, params, cb) {
    const dataWithProviders = this.getDataWithSearchProvider(data); // 15358
    const customData = dataWithProviders.data; // 15358
    const isOtherSearch = dataWithProviders.isOtherSearch;
    const geoJsonField = params.geoJsonField;
    const layer = params.layer;
    const query = params.query;
    const layerIndex = params.layerIndex;
    const layerClone = params.layerClone;
    const heatmapPoints = params.heatmapPoints;


    let i = 0;
    let isDraw = false; // 14752
    let start = 0; // 14752
    const end = ( this.processPageSize < customData.length ?
      this.processPageSize : customData.length); // 14752
    if (customData.length > 0 && layerIndex > -1) {
      SearchResultsProcessor.processSearchResultsParallel(data, async (itemData) => {
        // elementProcessingCallback
        const isValid = this.checkValidQuery(params.options);
        if (isValid) {
          if (i === start) {
            isDraw = false;
          }
          if (!isDraw) {
              isDraw = true;
              let n = i;
              for (let j = 0; j < end; j++) {
                  n = j + i;
                  if (n > customData.length - 1) {
                    break;
                  }
                  const iData = (isOtherSearch ? customData[n] : customData[n]._source);

                  this.drawAsset({
                    i: n,
                    itemData: iData,
                    geoJsonField,
                    layerIndex,
                    layer,
                    heatmapPoints,
                    customData,
                    layerClone,
                    getAssetPoint: params.getAssetPoint,
                    popupAssetSelectionPrimaryText: params.popupAssetSelectionPrimaryText,
                    popupAssetSelectionSecondaryText: params.popupAssetSelectionSecondaryText,
                    cb,
                  });
              }
              start = n + 1;
          }
        }
        i++;
      }, () => {
          // completionCallback
          if (cb && typeof cb === 'function') {
              cb();
          }
      });

    } else {
        if (cb && typeof cb === 'function') {
            cb();
        }
    }
  }
  resultSearchPagingAsync(fromSource, parseDataFn, data, params, remain, pageSize, canFetchMore, layer, layerIndex, options, cb) {
    const self = this;
    const startTimeDraw: any = new Date();
    parseDataFn(data, params, () => {
      if (remain > 0) {// if can fetch more data
        canFetchMore = true;
        const divide = Math.floor(remain / pageSize) ;
        let modulus = remain % pageSize;
        if (modulus > 0) {
            modulus = 1;
        }
        const len = divide + modulus;
        let countAsyncDone = len;
        if (this.showTiming) {
          console.log(`%c fromSource: ${fromSource} can fetch more, async len = ${len}`, 'color:cyan');
        }
        const from = pageSize;
        const self = this;

        const asyncIterable = {
          index: 0,
          len: len,
          [Symbol.asyncIterator]() {
              return {
                  current: this.index,
                  last: this.len,
                  next(): Promise<any> {
                    if (this.current < this.last) {
                        const subOp = cloneDeep(options);
                        subOp.from = (from * this.current) + pageSize;
                        params.pageIndex = this.current;
                        subOp.pageIndex = this.current;
                        if (this.showTiming) {
                          if (layerIndex) {
                            console.log(` from: ${fromSource}, layer[${layerIndex}]
                             start time ${(new Date()).toISOString()} for fetching data page: ${this.current}`);
                          } else {
                            console.log(` from: ${fromSource}
                              , start time ${(new Date()).toISOString()} for fetching data page: ${this.current}
                              \n\t, query = ${JSON.stringify(options.filter)}`);
                          }
                        }
                        self.searchClientService.search(subOp)
                        .then(
                          (data1) => {
                            const startTimeDraw1: any = new Date();
                            if (self.showTiming) {
                                console.log(` from: ${fromSource}, layer[${layerIndex}]
                                 end time ${startTimeDraw1.toISOString()}
                                  for fetching data page: ${subOp.pageIndex} & start time drawing asset`);
                            }
                            parseDataFn(data1, params, () => {
                                countAsyncDone--;
                                if (self.showTiming) {
                                  const endTimeDraw1 = new Date();
                                  console.log(` from: ${fromSource}, layer[${layerIndex}]
                                   end time drawing asset ${(new Date()).toISOString()}
                                    of page: ${subOp.pageIndex}`);
                                }
                                if (countAsyncDone === 0) {
                                  canFetchMore = false;
                                  if (self.showTiming) {
                                    const endTimeDraw1: any = new Date();
                                    const totalTimeDraw1: any = (endTimeDraw1 - startTimeDraw1) / 1000;
                                    console.log(` from: ${fromSource}, layer[${layerIndex}]
                                         end time drawing asset ${endTimeDraw1.toISOString()}
                                        \n\t, start time = ${startTimeDraw1.toISOString()}
                                        , TOTAL TIME: ${totalTimeDraw1} (seconds)`);
                                  }
                                  self.finishSearch(canFetchMore, layer, layerIndex, cb);
                                }
                            });
                        }, (err) => {
                          console.error('error in AddressMap:' + err);
                          if (self.showTiming) {
                            console.log(`(error) from: ${fromSource}, layer[${layerIndex}]
                             end time ${(new Date()).toISOString()}
                             for fetching data page: ${subOp.pageIndex}`);
                          }
                          countAsyncDone--;
                          if (countAsyncDone === 0) {
                            canFetchMore = false;
                            if (self.showTiming) {
                              console.log(`(error) from: ${fromSource}, layer[${layerIndex}]
                                 end time subsequent request ${(new Date()).toISOString()}`);
                            }
                            self.finishSearch(canFetchMore, layer, layerIndex, cb);
                          }
                        });
                        return Promise.resolve({ value: this.current++, done: false });
                    }
                    return Promise.resolve({ done: true });
                  }
              };
            }
        };
        async function main() {
          for await(const num of asyncIterable) {
            // console.log('num = ' + num);
          }
        }
        main()
        .then(r => {
          console.log(r);
        })
        .catch(err => console.log(err));
      } else {
        if (this.showTiming) {
          const endTimeDraw: any = new Date();
          const totalTimeDraw = (endTimeDraw - startTimeDraw) / 1000;
          console.log(` from: ${fromSource}, layer[${layerIndex}]
           end time drawing asset ${endTimeDraw.toISOString()}
          \n\t, start time: ${startTimeDraw.toISOString()}
          \n\t, total time: ${totalTimeDraw} (seconds)`);
        }
        canFetchMore = false;
        this.finishSearch(canFetchMore, layer, layerIndex, cb);
      }
    });
  }
  // the finishSearchAsync from selected-asset
  finishSearch(canFetchMore, layer, layerIndex, cb) {
    if (layer.type === 'heatmap' && this.mapObj) {
      this.mapObj.createHeatMap(layerIndex);
    }
    if ( !canFetchMore && cb && typeof cb === 'function') {
      cb();
    }
  }
  currentLocationCheckboxClick(e) {
    e.stopPropagation();
    if (e.target.checked) {
      this.locationElementIcon.setAttribute('class', 'material-icons ol-has-tooltip button-location-pulse');
      this.getLocation();
    }
  }

  addCurrentLocationCheckbox(keyName, element) {
    this.locationElementCheckboxId = keyName + 'Location';
    const checkbox = sclMapViews.createCheckbox(document, this.locationElementCheckboxId) as HTMLInputElement;

    this.locationElementIcon = document.createElement('i');
    this.locationElementIcon.setAttribute('class', 'material-icons ol-has-tooltip');
    this.locationElementIcon.innerHTML = 'my_location';

    this.locationElementLabel =  sclMapViews.createLabel(document, this.locationElementCheckboxId, null);
    this.locationElementLabel.setAttribute('class', 'control-globe');
    this.locationElementLabel.appendChild(this.locationElementIcon);
    this.locationElementLabelId = this.locationElementCheckboxId + '_label';
    this.locationElementLabel.id = this.locationElementLabelId;

    checkbox.onclick = (e: any) => {
      $('#' + this.locationElementLabelId).css('background', 'white');
      if (typeof this.currentLocationCheckBoxOnClick === 'function') {
        this.currentLocationCheckBoxOnClick(this.currentLocationCheckboxClick.bind(this, e));
      }
    };
    element.appendChild(checkbox);


    element.appendChild(this.locationElementLabel);
  }

  resetCheckLocationUI() {
    if (this.compType === MapComponentName.SELECTED_ASSET
      || this.compType === MapComponentName.STREET_ADDRESS) {
      if (this.locationElementIcon) {
        this.locationElementIcon.setAttribute('class', 'material-icons ol-has-tooltip');
      }

      const isChecked = $('#' + this.locationElementCheckboxId).is(':checked');
      if (this.locationElementCheckboxId && isChecked) {
        $('#' + this.locationElementCheckboxId).prop('checked', false);
      }
    } else if (this.compType === MapComponentName.BOUNDARY) {
      this.mapObj.resetCheckLocationUI();
    }

  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition.bind(this)
      , (err) => {
        this.resetCheckLocationUI();

        console.log(`ERROR code: (${err.code}) , message: ${err.message}`);
        if (err && err.message) {
          this.notificationService.error(err.message);
        }
      });
    }
  }

  showPosition(position) {
    if (this.geoAutoComplete != null) {
      this.geoAutoComplete.removeStreet(this.keyName);
    }
    if (this.addressId) {
      const fea = this.mapObj?.getFeatureById(this.addressId);
      if (fea) {
        this.mapObj?.removeFeature(fea);
      }
    }

    this.resetCheckLocationUI();

    this.currentLat = position.coords.latitude;
    this.currentLon = position.coords.longitude;

    this.currentLocation = [this.currentLat, this.currentLon];

    this.hasMapDragging = true;
    this.subLabelTiming = 'Get-Current-Location';

    if (typeof this.updateAddress === 'function') {
      this.updateAddress(this.currentLat, this.currentLon);
    }

    if (typeof this.updateMap === 'function') {
      this.updateMap(this.currentLat, this.currentLon, false, true);
    }

  }

  actionAfterMapReady(actionFn) {
    if (!this.checkMapReadyFirstLoad) {
      this.checkMapReadyFirstLoad = setInterval(() => {
        if (this.mapObj?.isMapReady) {
          clearInterval(this.checkMapReadyFirstLoad);
          this.checkMapReadyFirstLoad = null;
          if (typeof actionFn === 'function') {
            actionFn();
          }
        }
      }, 200);
    }
  }


  imageToBase64(url) {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          const image = new Image();
          image.onload = () => {
            resolve({base64: reader.result, image});
          };
          image.onerror = reject;
          image.src = reader.result as string;
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }
  debugGetExistedCacheImage = [];
  async cacheImage(url) {
    try {
      if (!url) {
        return;
      }
      let iconIndex = this.mapObj.cacheImageUrls.indexOf(url);
      if (iconIndex < 0) {
        if (this.mapObj.cacheImageRequesting.indexOf(url) > -1) {
          let elapsed = 0;

          const waitLoadingImage = setInterval(() => {
            iconIndex = this.mapObj.cacheImageUrls.indexOf(url);
            // console.log(`**** checking image url = ${url} is cached? index = ${iconIndex}`);
            if (iconIndex > -1) {
              // console.log(`**** image url = ${url} is cached`);
              clearInterval(waitLoadingImage);
            } else {
              elapsed += 200;
              if (elapsed >= 10000) { // timeout 10s
                clearInterval(waitLoadingImage);
                console.log(`Timeout waiting for image to cache: ${url}`);
              }
            }
          }, 200);
        } else {
          this.mapObj.cacheImageRequesting.push(url);

          try {
            const base64Obj: any = await this.imageToBase64(url);
            // console.log(`**** done getting image, url = ${url}`);
            const idx = this.mapObj.cacheImageRequesting.indexOf(url);
            if (idx > -1) {
              this.mapObj.cacheImageRequesting.splice(idx, 1); // this.mapObj.cacheImageRequesting.splice(url, 1);
            }
            
            const base64 = base64Obj.base64;
            const image = base64Obj.image;
            this.mapObj.cacheImageUrls.push(url);
            this.mapObj.cacheImageBase64s.push(base64);
            this.mapObj.cacheImages.push(image);
            
          } catch (error) {
            const idx = this.mapObj.cacheImageRequesting.indexOf(url);
            if (idx > -1) {
              this.mapObj.cacheImageRequesting.splice(idx, 1);
            }
            console.log(`Cache image error:`, error);
          }
          
        }

      } else {
        if (this.debugGetExistedCacheImage.indexOf(url) < 0) {
          // console.log(`**** cached image exists, url = ${url}`);
          this.debugGetExistedCacheImage.push(url);
        }
        
      }
    } catch (err) {
      console.log(`**** caching image url: ${url}, error: `, err);
    }

  }

  modifyBase64Image(base64origin, mode, value) {
    return new Promise((resolve, reject) => {
      if (!this.canvasRotate) {
        this.canvasRotate = document.createElement("canvas");
      }
      let base64 = base64origin;
      const img = new Image();
      img.onload = () => {

        const ctx = this.canvasRotate.getContext("2d");
        let dx = 0; let dy = 0;
        let width = img.width; let height = img.height;

        switch(mode) {
          case 'rotate':
            if (value != 0) {
              let size = img.width;
              if (img.width < img.height) { size = img.height; }
              width = size;
              height = size;

              this.canvasRotate.width = width;
              this.canvasRotate.height = height;

              ctx.translate(this.canvasRotate.width / 2, this.canvasRotate.height / 2);
              ctx.rotate(value * Math.PI / 180);
              dx = img.width / -2;
              dy = img.height / -2;
              ctx.drawImage(img, dx, dy);
              base64 = this.canvasRotate.toDataURL("image/png");
            }
            break;
          case 'scale':
            if (value != 1) {
              dx = 0;
              dy = 0;
              width *= Math.abs(value);
              height *= Math.abs(value);
              this.canvasRotate.width = width;
              this.canvasRotate.height = height;

              ctx.drawImage(img, dx, dy, width, height);
              base64 = this.canvasRotate.toDataURL("image/png");
            }
            break;
          case 'flip':
            if (value) { // flip
              this.canvasRotate.width = width;
              this.canvasRotate.height = height;

              dx = 0;
              dy = 0;
              ctx.translate(width, 0);
              ctx.scale(-1, 1);
              ctx.drawImage(img, dx, dy, width, height);
              base64 = this.canvasRotate.toDataURL("image/png");
            }
            break;
          default: break;
        }

        resolve(base64);
      };
      img.onerror = reject;
      img.src = base64origin;
    });
  }


  modifyImage(base64origin, rotate, scale, isFlip, infoId) {
    return new Promise(async (resolve, reject) => {
        try {
            let iconIndex = this.mapObj.cacheImageModifiedInfo.indexOf(infoId);
            if (iconIndex < 0) {
                if (this.mapObj.cacheImageModifiedInfoRequesting.indexOf(infoId) > -1) {
                    const waitLoadingImage = setInterval(() => {
                        iconIndex = this.mapObj.cacheImageModifiedInfo.indexOf(infoId);
                        if (iconIndex > -1) {
                            clearInterval(waitLoadingImage);
                            resolve(true);
                        }
                    }, 200);
                } else {
                    this.mapObj.cacheImageModifiedInfoRequesting.push(infoId);
                    let base64Modified = base64origin;
                    if (scale != 1) {
                      base64Modified = await this.modifyBase64Image(base64Modified
                        , 'scale', scale);
                    }
                    if (isFlip) {
                      base64Modified = await this.modifyBase64Image(base64Modified
                        , 'flip', true);
                    }
                    if (rotate != 0) {
                      base64Modified = await this.modifyBase64Image(base64Modified
                        , 'rotate', rotate);
                    }
                    this.mapObj.cacheImageModifiedInfoRequesting.splice(infoId);
                    this.mapObj.cacheImageModifiedBase64.push(base64Modified);
                    this.mapObj.cacheImageModifiedInfo.push(infoId);
                    resolve(true);
                }
            } else {
                resolve(true);
            }
        } catch (err) {
            reject(err);
        }


    });

  }

  multiLayers(mapParameters) {
    if (this.libName === MapLibraryName.OPEN_LAYER) {
      this.mapObj.multiLayers(mapParameters);
    }
  }

  addMapViewControl(element, compId, layerIds) {
    if (this.mapObj.mapViewLayers.length > 1 && this.libName === MapLibraryName.OPEN_LAYER) {
      this.mapObj.addMapViewControl(element, compId, layerIds);
    }
  }

  switchMapView(uiLabel, compId) {
    if (typeof uiLabel !== 'string' || uiLabel.trim().length == 0) {
      console.log(`*** invalid map view lable: ${uiLabel}`);
      return;
    }
    if (this.previousShowMapView !== uiLabel) {
      if (this.libName !== MapLibraryName.OPEN_LAYER) {
        console.log(`**** switching map view is not supported for ${this.libName}`);
        return;
      }
  
      this.mapObj.switchMapView(uiLabel, compId);
      this.previousShowMapView = uiLabel;
    }
    
  }

  // 20117
  registerMapWrapperChange(mapWrapper, onMoveEndFn, options?) {
    this.onMoveEndFn = onMoveEndFn;
    this.mapWrapperChangeOptions = options;

    this.mapWrapperChange = new ResizeObserver(entries => {
      if (entries && entries.length > 0) {
        if (this.mapObj && this.mapObj.isMapReady) {
          this.resizeMapTime = new Date();
          if (this.resizeMapTimeout === false) {
            this.resizeMapTimeout = true;
            setTimeout(this.mapChangeSizeEnd.bind(this, entries[0]), this.resizeMapThreshold);
          }
        }
      }

    });

    this.mapWrapperChange.observe(mapWrapper.nativeElement);
  }
  // 20117
  unregisterMapWrapperChange(mapWrapper) {
    this.onMoveEndFn = null;;
    this.mapWrapperChangeOptions = null;
    
    this.mapWrapperChange.unobserve(mapWrapper.nativeElement);

  }
  // 20117
  mapChangeSizeEnd(mapElem) {
    if (!mapElem || !mapElem.target || !this.mapObj || !this.mapObj.isMapReady) {
      // there has no map wrapper DOM element
      return;
    }
    const currentTime: any = new Date();
    const deltaTime = currentTime - this.resizeMapTime;
    if (deltaTime < this.resizeMapThreshold ) {
      setTimeout(this.mapChangeSizeEnd.bind(this, mapElem), this.resizeMapThreshold);
    } else {
      this.resizeMapTimeout = false;
      const width = mapElem.target.offsetWidth;
      if (!this.prevMapWrapperRect.width || !this.prevMapWrapperRect.height) {
        this.prevMapWrapperRect.width = mapElem.target.offsetWidth;
        this.prevMapWrapperRect.height = mapElem.target.offsetHeight;
      } else if (this.prevMapWrapperRect.width !== mapElem.target.offsetWidth) {
        this.prevMapWrapperRect.width = mapElem.target.offsetWidth;
      } else if (this.prevMapWrapperRect.height !== mapElem.target.offsetHeight) {
        this.prevMapWrapperRect.height = mapElem.target.offsetHeight;
      } else {
        // resized down, dont load assets
        return;
      }

      if (this.libName === MapLibraryName.OPEN_LAYER) {
        this.mapObj.map.updateSize();
        if (!this.hasResize) {
          // if window resize event raise then ignore this so that prevent onMoveEnd-loadAsset call multiple times
          this.hasMapWrapperResize = true;
          this.subLabelTiming = "Map Wrapper resize";

        }
        this.mapObj.setupMapControl();
      } else if (this.libName === MapLibraryName.GOOGLE) {
        this.onMoveEndFn(null);
      }

      if (this.mapWrapperChangeOptions?.setPrimaryScrollView) {
        this.mapWrapperChangeOptions.setPrimaryScrollView();// 14419#0053005
      }
      if (this.mapWrapperChangeOptions?.setSecondaryScrollView) {
        this.mapWrapperChangeOptions.setSecondaryScrollView();// 14419#0053005
      }
    }
  }

  setFieldActivation(mapElement, disabled, layerIds, hasAddressEntryFunction = true) {
    const label = $(mapElement).find('label');
    const input = $(mapElement).find('input');
    if (disabled) {
      input.map((index, elem) => {
        if ( layerIds.indexOf(elem.id) < 0 ) { $(elem).prop('disabled', true).attr('style', 'cursor:not-allowed;'); }
      });

      label.map((index, elem) => {
        if (layerIds.indexOf(elem.htmlFor) < 0 ) { $(elem).prop('disabled', true).attr('style', 'cursor:not-allowed;'); }
      });
      $('div[class*="disable-element"]').css({opacity: '0.92', cursor: 'not-allowed', 'pointer-events': 'none'});
    } else {
      input.map((index, elem) => {
        $(elem).prop('disabled', false).attr('style', 'cursor:pointer;');
      });
      label.map((index, elem) => {
        $(elem).prop('disabled', false).attr('style', 'cursor:pointer;');
      });
      $('div[class*="disable-element"]').css({opacity: '1', cursor: '', 'pointer-events': ''});
    }
    if (hasAddressEntryFunction == true && disabled == false) {
      this.setActivateButtonLookupAddress();
    }
    
  }
  
  setActivateButtonLookupAddress() {
    if (this.isDisableAddressEntry === true) {
      this.pencilElements.map(elem => {
        $(elem).prop('disabled', true).attr('style', 'cursor:not-allowed;');
      });
    } else {
      this.pencilElements.map(elem => {
        $(elem).prop('disabled', false).attr('style', 'cursor:pointer;');
      });
    }
  }
}
